/* eslint-disable quote-props */
export const CITIES_OF_UNITED_STATES = {
  'alabama': [
    { name: 'Alabaster' },
    { name: 'Albertville' },
    { name: 'Alexander City' },
    { name: 'Andalusia' },
    { name: 'Anniston' },
    { name: 'Arab' },
    { name: 'Athens' },
    { name: 'Atmore' },
    { name: 'Attalla' },
    { name: 'Auburn' },
    { name: 'Bay Minette' },
    { name: 'Bessemer' },
    { name: 'Birmingham' },
    { name: 'Boaz' },
    { name: 'Center Point' },
    { name: 'Chickasaw' },
    { name: 'Clanton' },
    { name: 'Cullman' },
    { name: 'Daphne' },
    { name: 'Decatur' },
    { name: 'Demopolis' },
    { name: 'Dothan' },
    { name: 'Enterprise' },
    { name: 'Eufaula' },
    { name: 'Fairfield' },
    { name: 'Fairhope' },
    { name: 'Florence' },
    { name: 'Foley' },
    { name: 'Forestdale' },
    { name: 'Fort Payne' },
    { name: 'Fort Rucker' },
    { name: 'Fultondale' },
    { name: 'Gadsden' },
    { name: 'Gardendale' },
    { name: 'Greenville' },
    { name: 'Guntersville' },
    { name: 'Hamilton' },
    { name: 'Hartselle' },
    { name: 'Helena' },
    { name: 'Homewood' },
    { name: 'Hoover' },
    { name: 'Hueytown' },
    { name: 'Huntsville' },
    { name: 'Irondale' },
    { name: 'Jacksonville' },
    { name: 'Jasper' },
    { name: 'Lanett' },
    { name: 'Leeds' },
    { name: 'Madison' },
    { name: 'Millbrook' },
    { name: 'Mobile' },
    { name: 'Monroeville' },
    { name: 'Montgomery' },
    { name: 'Moody' },
    { name: 'Mountain Brook' },
    { name: 'Muscle Shoals' },
    { name: 'Northport' },
    { name: 'Opelika' },
    { name: 'Opp' },
    { name: 'Oxford' },
    { name: 'Ozark' },
    { name: 'Pelham' },
    { name: 'Pell City' },
    { name: 'Phenix City' },
    { name: 'Pleasant Grove' },
    { name: 'Prattville' },
    { name: 'Prichard' },
    { name: 'Rainbow City' },
    { name: 'Roanoke' },
    { name: 'Russellville' },
    { name: 'Saks' },
    { name: 'Saraland' },
    { name: 'Scottsboro' },
    { name: 'Selma' },
    { name: 'Sheffield' },
    { name: 'Smiths' },
    { name: 'Southside' },
    { name: 'Sylacauga' },
    { name: 'Talladega' },
    { name: 'Tarrant' },
    { name: 'Theodore' },
    { name: 'Tillmans Corner' },
    { name: 'Troy' },
    { name: 'Trussville' },
    { name: 'Tuscaloosa' },
    { name: 'Tuscumbia' },
    { name: 'Tuskegee' },
    { name: 'Valley' },
    { name: 'Vestavia Hills' },
  ],
  'alaska': [
    { name: 'Anchorage' },
    { name: 'College' },
    { name: 'Fairbanks' },
    { name: 'Juneau and' },
    { name: 'Kenai' },
    { name: 'Ketchikan' },
    { name: 'Knik-Fairview' },
    { name: 'Kodiak' },
    { name: 'Lakes' },
    { name: 'Sitka and' },
  ],
  'arizona': [
    { name: 'Apache Junction' },
    { name: 'Avondale' },
    { name: 'Bisbee' },
    { name: 'Buckeye' },
    { name: 'Bullhead City' },
    { name: 'Camp Verde' },
    { name: 'Casa Grande' },
    { name: 'Casas Adobes' },
    { name: 'Catalina' },
    { name: 'Catalina Foothills' },
    { name: 'Chandler' },
    { name: 'Chino Valley' },
    { name: 'Coolidge' },
    { name: 'Cottonwood' },
    { name: 'Cottonwood-Verde Village' },
    { name: 'Dewey-Humboldt' },
    { name: 'Douglas' },
    { name: 'Drexel Heights' },
    { name: 'El Mirage' },
    { name: 'Eloy' },
    { name: 'Flagstaff' },
    { name: 'Florence' },
    { name: 'Flowing Wells' },
    { name: 'Fortuna Foothills' },
    { name: 'Fountain Hills' },
    { name: 'Gilbert' },
    { name: 'Glendale' },
    { name: 'Globe' },
    { name: 'Gold Camp' },
    { name: 'Goodyear' },
    { name: 'Green Valley' },
    { name: 'Kingman' },
    { name: 'Lake Havasu City' },
    { name: 'Marana' },
    { name: 'Mesa' },
    { name: 'Mohave Valley' },
    { name: 'New Kingman-Butler' },
    { name: 'New River' },
    { name: 'Nogales' },
    { name: 'Oro Valley' },
    { name: 'Page' },
    { name: 'Paradise Valley' },
    { name: 'Payson' },
    { name: 'Peoria' },
    { name: 'Phoenix' },
    { name: 'Picture Rocks' },
    { name: 'Prescott' },
    { name: 'Prescott Valley' },
    { name: 'Safford' },
    { name: 'San Luis' },
    { name: 'Scottsdale' },
    { name: 'Sedona' },
    { name: 'Show Low' },
    { name: 'Sierra Vista' },
    { name: 'Sierra Vista Southeast' },
    { name: 'Somerton' },
    { name: 'Sun City' },
    { name: 'Sun City West' },
    { name: 'Sun Lakes' },
    { name: 'Surprise' },
    { name: 'Tanque Verde' },
    { name: 'Tempe' },
    { name: 'Tuba City' },
    { name: 'Tucson' },
    { name: 'Tucson Estates' },
    { name: 'Winslow' },
    { name: 'Yuma' },
  ],
  'arkansas': [
    { name: 'Arkadelphia' },
    { name: 'Batesville' },
    { name: 'Bella Vista' },
    { name: 'Benton' },
    { name: 'Bentonville' },
    { name: 'Blytheville' },
    { name: 'Bryant' },
    { name: 'Cabot' },
    { name: 'Camden' },
    { name: 'Clarksville' },
    { name: 'Conway' },
    { name: 'Crossett' },
    { name: 'El Dorado' },
    { name: 'Fayetteville' },
    { name: 'Forrest City' },
    { name: 'Fort Smith' },
    { name: 'Greenwood' },
    { name: 'Harrison' },
    { name: 'Heber Springs' },
    { name: 'Helena' },
    { name: 'Hope' },
    { name: 'Hot Springs' },
    { name: 'Hot Springs Village' },
    { name: 'Jacksonville' },
    { name: 'Jonesboro' },
    { name: 'Little Rock' },
    { name: 'Magnolia' },
    { name: 'Malvern' },
    { name: 'Marion' },
    { name: 'Maumelle' },
    { name: 'Monticello' },
    { name: 'Morrilton' },
    { name: 'Mountain Home' },
    { name: 'Newport' },
    { name: 'North Little Rock' },
    { name: 'Osceola' },
    { name: 'Paragould' },
    { name: 'Pine Bluff' },
    { name: 'Pocahontas' },
    { name: 'Rogers' },
    { name: 'Russellville' },
    { name: 'Searcy' },
    { name: 'Sherwood' },
    { name: 'Siloam Springs' },
    { name: 'Springdale' },
    { name: 'Stuttgart' },
    { name: 'Texarkana' },
    { name: 'Trumann' },
    { name: 'Van Buren' },
    { name: 'Warren' },
    { name: 'West Helena' },
    { name: 'West Memphis' },
    { name: 'Wynne' },
  ],
  'california': [
    { name: 'Adelanto' },
    { name: 'Agoura Hills' },
    { name: 'Alameda' },
    { name: 'Alamo' },
    { name: 'Albany' },
    { name: 'Alhambra' },
    { name: 'Aliso Viejo' },
    { name: 'Alondra Park' },
    { name: 'Alpine' },
    { name: 'Alta Sierra' },
    { name: 'Altadena' },
    { name: 'Alum Rock' },
    { name: 'American Canyon' },
    { name: 'Anaheim' },
    { name: 'Anderson' },
    { name: 'Antioch' },
    { name: 'Apple Valley' },
    { name: 'Aptos' },
    { name: 'Arcadia' },
    { name: 'Arcata' },
    { name: 'Arden-Arcade' },
    { name: 'Arroyo Grande' },
    { name: 'Artesia' },
    { name: 'Arvin' },
    { name: 'Ashland' },
    { name: 'Atascadero' },
    { name: 'Atherton' },
    { name: 'Atwater' },
    { name: 'Auburn' },
    { name: 'August' },
    { name: 'Avenal' },
    { name: 'Avocado Heights' },
    { name: 'Azusa' },
    { name: 'Bakersfield' },
    { name: 'Baldwin Park' },
    { name: 'Banning' },
    { name: 'Barstow' },
    { name: 'Bay Point' },
    { name: 'Baywood-Los Osos' },
    { name: 'Beaumont' },
    { name: 'Bell' },
    { name: 'Bell Gardens' },
    { name: 'Bellflower' },
    { name: 'Belmont' },
    { name: 'Benicia' },
    { name: 'Berkeley' },
    { name: 'Bermuda Dunes' },
    { name: 'Beverly Hills' },
    { name: 'Blackhawk-Camino Tassajara' },
    { name: 'Bloomington' },
    { name: 'Blythe' },
    { name: 'Bonadelle Ranchos-Madera Ranchos' },
    { name: 'Bonita' },
    { name: 'Bostonia' },
    { name: 'Boyes Hot Springs' },
    { name: 'Brawley' },
    { name: 'Brea' },
    { name: 'Brentwood' },
    { name: 'Buena Park' },
    { name: 'Burbank' },
    { name: 'Burlingame' },
    { name: 'Calabasas' },
    { name: 'Calexico' },
    { name: 'California City' },
    { name: 'Calimesa' },
    { name: 'Calipatria' },
    { name: 'Camarillo' },
    { name: 'Cambria' },
    { name: 'Cameron Park' },
    { name: 'Camp Pendleton North' },
    { name: 'Camp Pendleton South' },
    { name: 'Campbell' },
    { name: 'Canyon Lake' },
    { name: 'Capitola' },
    { name: 'Carlsbad' },
    { name: 'Carmichael' },
    { name: 'Carpinteria' },
    { name: 'Carson' },
    { name: 'Casa de Oro-Mount Helix' },
    { name: 'Castro Valley' },
    { name: 'Castroville' },
    { name: 'Cathedral City' },
    { name: 'Ceres' },
    { name: 'Cerritos' },
    { name: 'Charter Oak' },
    { name: 'Cherryland' },
    { name: 'Chico' },
    { name: 'Chino' },
    { name: 'Chino Hills' },
    { name: 'Chowchilla' },
    { name: 'Chula Vista' },
    { name: 'Citrus' },
    { name: 'Citrus Heights' },
    { name: 'Claremont' },
    { name: 'Clayton' },
    { name: 'Clearlake' },
    { name: 'Cloverdale' },
    { name: 'Clovis' },
    { name: 'Coachella' },
    { name: 'Coalinga' },
    { name: 'Colton' },
    { name: 'Commerce' },
    { name: 'Compton' },
    { name: 'Concord' },
    { name: 'Corcoran' },
    { name: 'Corning' },
    { name: 'Corona' },
    { name: 'Coronado' },
    { name: 'Corte Madera' },
    { name: 'Costa Mesa' },
    { name: 'Cotati' },
    { name: 'Coto de Caza' },
    { name: 'Country Club' },
    { name: 'Covina' },
    { name: 'Crestline' },
    { name: 'Cudahy' },
    { name: 'Culver City' },
    { name: 'Cupertino' },
    { name: 'Cypress' },
    { name: 'Daly City' },
    { name: 'Dana Point' },
    { name: 'Danville' },
    { name: 'Davis' },
    { name: 'Del Aire' },
    { name: 'Delano' },
    { name: 'Delhi' },
    { name: 'Desert Hot Springs' },
    { name: 'Diamond Bar' },
    { name: 'Dinuba' },
    { name: 'Discovery Bay' },
    { name: 'Dixon' },
    { name: 'Downey' },
    { name: 'Duarte' },
    { name: 'Dublin' },
    { name: 'Earlimart' },
    { name: 'East Compton' },
    { name: 'East Foothills' },
    { name: 'East Hemet' },
    { name: 'East La Mirada' },
    { name: 'East Los Angeles' },
    { name: 'East Palo Alto' },
    { name: 'East Pasadena' },
    { name: 'East Porterville' },
    { name: 'East San Gabriel' },
    { name: 'El Cajon' },
    { name: 'El Centro' },
    { name: 'El Cerrito' },
    { name: 'El Dorado Hills' },
    { name: 'El Monte' },
    { name: 'El Paso de Robles' },
    { name: 'El Rio' },
    { name: 'El Segundo' },
    { name: 'El Sobrante' },
    { name: 'Elk Grove' },
    { name: 'Emeryville' },
    { name: 'Encinitas' },
    { name: 'Escondido' },
    { name: 'Eureka' },
    { name: 'Exeter' },
    { name: 'Fair Oaks' },
    { name: 'Fairfax' },
    { name: 'Fairfield' },
    { name: 'Fairview' },
    { name: 'Fallbrook' },
    { name: 'Farmersville' },
    { name: 'Fillmore' },
    { name: 'Florence-Graham' },
    { name: 'Florin' },
    { name: 'Folsom' },
    { name: 'Fontana' },
    { name: 'Foothill Farms' },
    { name: 'Foothill Ranch' },
    { name: 'Fort Bragg' },
    { name: 'Fortuna' },
    { name: 'Foster City' },
    { name: 'Fountain Valley' },
    { name: 'Fremont' },
    { name: 'Fresno' },
    { name: 'Fullerton' },
    { name: 'Galt' },
    { name: 'Garden Acres' },
    { name: 'Garden Grove' },
    { name: 'Gardena' },
    { name: 'Gilroy' },
    { name: 'Glen Avon' },
    { name: 'Glendale' },
    { name: 'Glendora' },
    { name: 'Gold River' },
    { name: 'Golden Hills' },
    { name: 'Goleta' },
    { name: 'Gonzales' },
    { name: 'Grand Terrace' },
    { name: 'Granite Bay' },
    { name: 'Grass Valley' },
    { name: 'Greenfield' },
    { name: 'Grover Beach' },
    { name: 'Hacienda Heights' },
    { name: 'Half Moon Bay' },
    { name: 'Hanford' },
    { name: 'Hawaiian Gardens' },
    { name: 'Hawthorne' },
    { name: 'Hayward' },
    { name: 'Healdsburg' },
    { name: 'Hemet' },
    { name: 'Hercules' },
    { name: 'Hermosa Beach' },
    { name: 'Hesperia' },
    { name: 'Highland' },
    { name: 'Hillsborough' },
    { name: 'Hollister' },
    { name: 'Home Gardens' },
    { name: 'Huntington Beach' },
    { name: 'Huntington Park' },
    { name: 'Huron' },
    { name: 'Imperial' },
    { name: 'Imperial Beach' },
    { name: 'Indio' },
    { name: 'Inglewood' },
    { name: 'Interlaken' },
    { name: 'Ione' },
    { name: 'Irvine' },
    { name: 'Isla Vista' },
    { name: 'Kentfield' },
    { name: 'Kerman' },
    { name: 'King City' },
    { name: 'Kingsburg' },
    { name: 'La Canada Flintridge' },
    { name: 'La Crescenta-Montrose' },
    { name: 'La Habra' },
    { name: 'La Mesa' },
    { name: 'La Mirada' },
    { name: 'La Palma' },
    { name: 'La Presa' },
    { name: 'La Puente' },
    { name: 'La Quinta' },
    { name: 'La Riviera' },
    { name: 'La Verne' },
    { name: 'Ladera Heights' },
    { name: 'Lafayette' },
    { name: 'Laguna' },
    { name: 'Laguna Beach' },
    { name: 'Laguna Hills' },
    { name: 'Laguna Niguel' },
    { name: 'Laguna West-Lakeside' },
    { name: 'Laguna Woods' },
    { name: 'Lake Arrowhead' },
    { name: 'Lake Elsinore' },
    { name: 'Lake Forest' },
    { name: 'Lake Los Angeles' },
    { name: 'Lakeside' },
    { name: 'Lakewood' },
    { name: 'Lamont' },
    { name: 'Lancaster' },
    { name: 'Larkfield-Wikiup' },
    { name: 'Larkspur' },
    { name: 'Lathrop' },
    { name: 'Lawndale' },
    { name: 'Lemon Grove' },
    { name: 'Lemoore' },
    { name: 'Lennox' },
    { name: 'Lincoln' },
    { name: 'Linda' },
    { name: 'Lindsay' },
    { name: 'Live Oak' },
    { name: 'Livermore' },
    { name: 'Livingston' },
    { name: 'Lodi' },
    { name: 'Loma Linda' },
    { name: 'Lomita' },
    { name: 'Lompoc' },
    { name: 'Long Beach' },
    { name: 'Loomis' },
    { name: 'Los Alamitos' },
    { name: 'Los Altos' },
    { name: 'Los Altos Hills' },
    { name: 'Los Angeles' },
    { name: 'Los Banos' },
    { name: 'Los Gatos' },
    { name: 'Lucas Valley-Marinwood' },
    { name: 'Lynwood' },
    { name: 'Madera' },
    { name: 'Madera Acres' },
    { name: 'Magalia' },
    { name: 'Malibu' },
    { name: 'Mammoth Lakes' },
    { name: 'Manhattan Beach' },
    { name: 'Manteca' },
    { name: 'Marina' },
    { name: 'Marina del Rey' },
    { name: 'Martinez' },
    { name: 'Marysville' },
    { name: 'Maywood' },
    { name: 'McFarland' },
    { name: 'McKinleyville' },
    { name: 'Mendota' },
    { name: 'Menlo Park' },
    { name: 'Mentone' },
    { name: 'Merced' },
    { name: 'Mill Valley' },
    { name: 'Millbrae' },
    { name: 'Milpitas' },
    { name: 'Mira Loma' },
    { name: 'Mira Monte' },
    { name: 'Mission Viejo' },
    { name: 'Modesto' },
    { name: 'Monrovia' },
    { name: 'Montclair' },
    { name: 'Montebello' },
    { name: 'Montecito' },
    { name: 'Monterey' },
    { name: 'Monterey Park' },
    { name: 'Moorpark' },
    { name: 'Moraga' },
    { name: 'Moreno Valley' },
    { name: 'Morgan Hill' },
    { name: 'Morro Bay' },
    { name: 'Mountain View' },
    { name: 'Murrieta' },
    { name: 'Muscoy' },
    { name: 'Napa' },
    { name: 'National City' },
    { name: 'Newark' },
    { name: 'Newman' },
    { name: 'Newport Beach' },
    { name: 'Nipomo' },
    { name: 'Norco' },
    { name: 'North Auburn' },
    { name: 'North Fair Oaks' },
    { name: 'North Highlands' },
    { name: 'Norwalk' },
    { name: 'Novato' },
    { name: 'Oakdale' },
    { name: 'Oakland' },
    { name: 'Oakley' },
    { name: 'Oceano' },
    { name: 'Oceanside' },
    { name: 'Oildale' },
    { name: 'Ojai' },
    { name: 'Olivehurst' },
    { name: 'Ontario' },
    { name: 'Opal Cliffs' },
    { name: 'Orange' },
    { name: 'Orange Cove' },
    { name: 'Orangevale' },
    { name: 'Orcutt' },
    { name: 'Orinda' },
    { name: 'Orland' },
    { name: 'Orosi' },
    { name: 'Oroville' },
    { name: 'Oroville East' },
    { name: 'Oxnard' },
    { name: 'Pacific Grove' },
    { name: 'Pacifica' },
    { name: 'Palm Desert' },
    { name: 'Palm Springs' },
    { name: 'Palmdale' },
    { name: 'Palo Alto' },
    { name: 'Palos Verdes Estates' },
    { name: 'Paradise' },
    { name: 'Paramount' },
    { name: 'Parkway-South Sacramento' },
    { name: 'Parlier' },
    { name: 'Pasadena' },
    { name: 'Patterson' },
    { name: 'Pedley' },
    { name: 'Perris' },
    { name: 'Petaluma' },
    { name: 'Pico Rivera' },
    { name: 'Piedmont' },
    { name: 'Pinole' },
    { name: 'Pismo Beach' },
    { name: 'Pittsburg' },
    { name: 'Placentia' },
    { name: 'Placerville' },
    { name: 'Pleasant Hill' },
    { name: 'Pleasanton' },
    { name: 'Pomona' },
    { name: 'Port Hueneme' },
    { name: 'Porterville' },
    { name: 'Portola Hills' },
    { name: 'Poway' },
    { name: 'Prunedale' },
    { name: 'Quartz Hill' },
    { name: 'Ramona' },
    { name: 'Rancho Cordova' },
    { name: 'Rancho Cucamonga' },
    { name: 'Rancho Mirage' },
    { name: 'Rancho Palos Verdes' },
    { name: 'Rancho San Diego' },
    { name: 'Rancho Santa Margarita' },
    { name: 'Red Bluff' },
    { name: 'Redding' },
    { name: 'Redlands' },
    { name: 'Redondo Beach' },
    { name: 'Redwood City' },
    { name: 'Reedley' },
    { name: 'Rialto' },
    { name: 'Richmond' },
    { name: 'Ridgecrest' },
    { name: 'Rio del Mar' },
    { name: 'Rio Linda' },
    { name: 'Ripon' },
    { name: 'Riverbank' },
    { name: 'Riverside' },
    { name: 'Rocklin' },
    { name: 'Rodeo' },
    { name: 'Rohnert Park' },
    { name: 'Rolling Hills Estates' },
    { name: 'Rosamond' },
    { name: 'Rosedale' },
    { name: 'Roseland' },
    { name: 'Rosemead' },
    { name: 'Rosemont' },
    { name: 'Roseville' },
    { name: 'Rossmoor' },
    { name: 'Rowland Heights' },
    { name: 'Rubidoux' },
    { name: 'Sacramento' },
    { name: 'Salida' },
    { name: 'Salinas' },
    { name: 'San Anselmo' },
    { name: 'San Bernardino' },
    { name: 'San Bruno' },
    { name: 'San Buenaventura' },
    { name: 'San Carlos' },
    { name: 'San Clemente' },
    { name: 'San Diego' },
    { name: 'San Diego Country Estates' },
    { name: 'San Dimas' },
    { name: 'San Fernando' },
    { name: 'San Francisco' },
    { name: 'San Gabriel' },
    { name: 'San Jacinto' },
    { name: 'San Jose' },
    { name: 'San Juan Capistrano' },
    { name: 'San Leandro' },
    { name: 'San Lorenzo' },
    { name: 'San Luis Obispo' },
    { name: 'San Marcos' },
    { name: 'San Marino' },
    { name: 'San Mateo' },
    { name: 'San Pablo' },
    { name: 'San Rafael' },
    { name: 'San Ramon' },
    { name: 'Sanger' },
    { name: 'Santa Ana' },
    { name: 'Santa Barbara' },
    { name: 'Santa Clara' },
    { name: 'Santa Clarita' },
    { name: 'Santa Cruz' },
    { name: 'Santa Fe Springs' },
    { name: 'Santa Maria' },
    { name: 'Santa Monica' },
    { name: 'Santa Paula' },
    { name: 'Santa Rosa' },
    { name: 'Santee' },
    { name: 'Saratoga' },
    { name: 'Sausalito' },
    { name: 'Scotts Valley' },
    { name: 'Seal Beach' },
    { name: 'Seaside' },
    { name: 'Sebastopol' },
    { name: 'Selma' },
    { name: 'Shafter' },
    { name: 'Shasta Lake' },
    { name: 'Sierra Madre' },
    { name: 'Signal Hill' },
    { name: 'Simi Valley' },
    { name: 'Solana Beach' },
    { name: 'Soledad' },
    { name: 'Sonoma' },
    { name: 'South El Monte' },
    { name: 'South Gate' },
    { name: 'South Lake Tahoe' },
    { name: 'South Oroville' },
    { name: 'South Pasadena' },
    { name: 'South San Francisco' },
    { name: 'South San Gabriel' },
    { name: 'South San Jose Hills' },
    { name: 'South Whittier' },
    { name: 'South Yuba City' },
    { name: 'Spring Valley' },
    { name: 'Stanford' },
    { name: 'Stanton' },
    { name: 'Stockton' },
    { name: 'Suisun City' },
    { name: 'Sun City' },
    { name: 'Sunnyvale' },
    { name: 'Susanville' },
    { name: 'Taft' },
    { name: 'Tamalpais-Homestead Valley' },
    { name: 'Tehachapi' },
    { name: 'Temecula' },
    { name: 'Temple City' },
    { name: 'Thermalito' },
    { name: 'Thousand Oaks' },
    { name: 'Tiburon' },
    { name: 'Torrance' },
    { name: 'Tracy' },
    { name: 'Truckee' },
    { name: 'Tulare' },
    { name: 'Turlock' },
    { name: 'Tustin' },
    { name: 'Tustin Foothills' },
    { name: 'Twentynine Palms' },
    { name: 'Twentynine Palms Base' },
    { name: 'Ukiah' },
    { name: 'Union City' },
    { name: 'Upland' },
    { name: 'Vacaville' },
    { name: 'Valinda' },
    { name: 'Valle Vista' },
    { name: 'Vallejo' },
    { name: 'Valley Center' },
    { name: 'Vandenberg AFB' },
    { name: 'Victorville' },
    { name: 'View Park-Windsor Hills' },
    { name: 'Vincent' },
    { name: 'Vineyard' },
    { name: 'Visalia' },
    { name: 'Vista' },
    { name: 'Walnut' },
    { name: 'Walnut Creek' },
    { name: 'Walnut Park' },
    { name: 'Wasco' },
    { name: 'Waterford' },
    { name: 'Watsonville' },
    { name: 'West Athens' },
    { name: 'West Carson' },
    { name: 'West Covina' },
    { name: 'West Hollywood' },
    { name: 'West Modesto' },
    { name: 'West Puente Valley' },
    { name: 'West Sacramento' },
    { name: 'West Whittier-Los Nietos' },
    { name: 'Westlake Village' },
    { name: 'Westminster' },
    { name: 'Westmont' },
    { name: 'Whittier' },
    { name: 'Wildomar' },
    { name: 'Willowbrook' },
    { name: 'Willows' },
    { name: 'Windsor' },
    { name: 'Winter Gardens' },
    { name: 'Winters' },
    { name: 'Winton' },
    { name: 'Woodcrest' },
    { name: 'Woodlake' },
    { name: 'Woodland' },
    { name: 'Yorba Linda' },
    { name: 'Yreka' },
    { name: 'Yuba City' },
    { name: 'Yucaipa' },
    { name: 'Yucca Valley' },
  ],
  'colorado': [
    { name: 'Air Force Academy' },
    { name: 'Alamosa' },
    { name: 'Applewood' },
    { name: 'Arvada' },
    { name: 'Aurora' },
    { name: 'Berkley' },
    { name: 'Black Forest' },
    { name: 'Boulder' },
    { name: 'Brighton' },
    { name: 'Broomfield' },
    { name: 'Canon City' },
    { name: 'Castle Rock' },
    { name: 'Castlewood' },
    { name: 'Cimarron Hills' },
    { name: 'Clifton' },
    { name: 'Colorado Springs' },
    { name: 'Columbine' },
    { name: 'Commerce City' },
    { name: 'Cortez' },
    { name: 'Craig' },
    { name: 'Delta' },
    { name: 'Denver' },
    { name: 'Derby' },
    { name: 'Durango' },
    { name: 'Edwards' },
    { name: 'Englewood' },
    { name: 'Erie' },
    { name: 'Evans' },
    { name: 'Evergreen' },
    { name: 'Federal Heights' },
    { name: 'Fort Carson' },
    { name: 'Fort Collins' },
    { name: 'Fort Lupton' },
    { name: 'Fort Morgan' },
    { name: 'Fountain' },
    { name: 'Fruita' },
    { name: 'Fruitvale' },
    { name: 'Glenwood Springs' },
    { name: 'Golden' },
    { name: 'Grand Junction' },
    { name: 'Greeley' },
    { name: 'Greenwood Village' },
    { name: 'Gunbarrel' },
    { name: 'Highlands Ranch' },
    { name: 'Ken Caryl' },
    { name: 'La Junta' },
    { name: 'Lafayette' },
    { name: 'Lakewood' },
    { name: 'Lamar' },
    { name: 'Littleton' },
    { name: 'Longmont' },
    { name: 'Louisville' },
    { name: 'Loveland' },
    { name: 'Montrose' },
    { name: 'Northglenn' },
    { name: 'Orchard Mesa' },
    { name: 'Parker' },
    { name: 'Pueblo' },
    { name: 'Pueblo West' },
    { name: 'Redlands' },
    { name: 'Rifle' },
    { name: 'Security-Widefield' },
    { name: 'Sherrelwood' },
    { name: 'Southglenn' },
    { name: 'Steamboat Springs' },
    { name: 'Sterling' },
    { name: 'Stonegate' },
    { name: 'Stratmoor' },
    { name: 'Superior' },
    { name: 'The Pinery' },
    { name: 'Thornton' },
    { name: 'Trinidad' },
    { name: 'Twin Lakes' },
    { name: 'Welby' },
    { name: 'Westminster' },
    { name: 'Wheat Ridge' },
    { name: 'Windsor' },
    { name: 'Woodland Park' },
    { name: 'Woodmoor' },
  ],
  'connecticut': [
    { name: 'Ansonia' },
    { name: 'Avon' },
    { name: 'Berlin' },
    { name: 'Bethel' },
    { name: 'Bloomfield' },
    { name: 'Branford' },
    { name: 'Bridgeport' },
    { name: 'Bristol' },
    { name: 'Brookfield' },
    { name: 'Brooklyn' },
    { name: 'Burlington' },
    { name: 'Canton' },
    { name: 'Central Manchester' },
    { name: 'Cheshire' },
    { name: 'Clinton' },
    { name: 'Colchester' },
    { name: 'Conning Towers-Nautilus Park' },
    { name: 'Coventry' },
    { name: 'Cromwell' },
    { name: 'Danbury' },
    { name: 'Darien' },
    { name: 'Derby' },
    { name: 'Durham' },
    { name: 'East Haddam' },
    { name: 'East Hampton' },
    { name: 'East Hartford' },
    { name: 'East Haven' },
    { name: 'East Lyme' },
    { name: 'East Windsor' },
    { name: 'Easton' },
    { name: 'Ellington' },
    { name: 'Enfield' },
    { name: 'Essex' },
    { name: 'Fairfield' },
    { name: 'Farmington' },
    { name: 'Glastonbury' },
    { name: 'Glastonbury Center' },
    { name: 'Granby' },
    { name: 'Greenwich' },
    { name: 'Griswold' },
    { name: 'Groton' },
    { name: 'Guilford' },
    { name: 'Haddam' },
    { name: 'Hamden' },
    { name: 'Hartford' },
    { name: 'Hebron' },
    { name: 'Kensington' },
    { name: 'Killingly' },
    { name: 'Killingworth' },
    { name: 'Lebanon' },
    { name: 'Ledyard' },
    { name: 'Litchfield' },
    { name: 'Madison' },
    { name: 'Manchester' },
    { name: 'Mansfield' },
    { name: 'Meriden' },
    { name: 'Middlebury' },
    { name: 'Middletown' },
    { name: 'Milford' },
    { name: 'Monroe' },
    { name: 'Montville' },
    { name: 'Naugatuck' },
    { name: 'New Britain' },
    { name: 'New Canaan' },
    { name: 'New Fairfield' },
    { name: 'New Hartford' },
    { name: 'New Haven' },
    { name: 'New London' },
    { name: 'New Milford' },
    { name: 'Newington' },
    { name: 'Newtown' },
    { name: 'North Branford' },
    { name: 'North Haven' },
    { name: 'Norwalk' },
    { name: 'Norwich' },
    { name: 'Oakville' },
    { name: 'Old Lyme' },
    { name: 'Old Saybrook' },
    { name: 'Orange' },
    { name: 'Oxford' },
    { name: 'Plainfield' },
    { name: 'Plainville' },
    { name: 'Plymouth' },
    { name: 'Portland' },
    { name: 'Prospect' },
    { name: 'Putnam' },
    { name: 'Putnam District' },
    { name: 'Redding' },
    { name: 'Ridgefield' },
    { name: 'Rockville' },
    { name: 'Rocky Hill' },
    { name: 'Seymour' },
    { name: 'Shelton' },
    { name: 'Simsbury' },
    { name: 'Somers' },
    { name: 'South Windsor' },
    { name: 'Southbury' },
    { name: 'Southington' },
    { name: 'Southwood Acres' },
    { name: 'Stafford' },
    { name: 'Stamford' },
    { name: 'Stonington' },
    { name: 'Storrs' },
    { name: 'Stratford' },
    { name: 'Suffield' },
    { name: 'Thomaston' },
    { name: 'Thompson' },
    { name: 'Thompsonville' },
    { name: 'Tolland' },
    { name: 'Torrington' },
    { name: 'Trumbull' },
    { name: 'Vernon' },
    { name: 'Wallingford' },
    { name: 'Wallingford Center' },
    { name: 'Waterbury' },
    { name: 'Waterford' },
    { name: 'Watertown' },
    { name: 'West Hartford' },
    { name: 'West Haven' },
    { name: 'Westbrook' },
    { name: 'Weston' },
    { name: 'Westport' },
    { name: 'Wethersfield' },
    { name: 'Willimantic' },
    { name: 'Wilton' },
    { name: 'Winchester' },
    { name: 'Windham' },
    { name: 'Windsor' },
    { name: 'Windsor Locks' },
    { name: 'Winsted' },
    { name: 'Wolcott' },
    { name: 'Woodbridge' },
    { name: 'Woodbury' },
    { name: 'Woodstock' },
  ],
  'delaware': [
    { name: 'Bear' },
    { name: 'Brookside' },
    { name: 'Claymont' },
    { name: 'Dover' },
    { name: 'Glasgow' },
    { name: 'Hockessin' },
    { name: 'Middletown' },
    { name: 'Milford' },
    { name: 'Newark' },
    { name: 'North Star' },
    { name: 'Pike Creek' },
    { name: 'Seaford' },
    { name: 'Wilmington' },
    { name: 'Wilmington Manor' },
  ],
  'florida': [
    { name: 'Alachua' },
    { name: 'Altamonte Springs' },
    { name: 'Andover' },
    { name: 'Apollo Beach' },
    { name: 'Apopka' },
    { name: 'Arcadia' },
    { name: 'Atlantic Beach' },
    { name: 'Auburndale' },
    { name: 'Aventura' },
    { name: 'Avon Park' },
    { name: 'Azalea Park' },
    { name: 'Bartow' },
    { name: 'Bayonet Point' },
    { name: 'Bayshore Gardens' },
    { name: 'Beacon Square' },
    { name: 'Bee Ridge' },
    { name: 'Bellair-Meadowbrook Terrace' },
    { name: 'Belle Glade' },
    { name: 'Bellview' },
    { name: 'Beverly Hills' },
    { name: 'Bloomingdale' },
    { name: 'Boca Del Mar' },
    { name: 'Boca Raton' },
    { name: 'Bonita Springs' },
    { name: 'Boynton Beach' },
    { name: 'Bradenton' },
    { name: 'Brandon' },
    { name: 'Brent' },
    { name: 'Broadview Park' },
    { name: 'Brooksville' },
    { name: 'Brownsville' },
    { name: 'Callaway' },
    { name: 'Cape Canaveral' },
    { name: 'Cape Coral' },
    { name: 'Carol City' },
    { name: 'Casselberry' },
    { name: 'Century Village' },
    { name: 'Cheval' },
    { name: 'Citrus Park' },
    { name: 'Citrus Ridge' },
    { name: 'Clearwater' },
    { name: 'Clermont' },
    { name: 'Clewiston' },
    { name: 'Cocoa' },
    { name: 'Cocoa Beach' },
    { name: 'Coconut Creek' },
    { name: 'Collier Manor-Cresthaven' },
    { name: 'Conway' },
    { name: 'Cooper City' },
    { name: 'Coral Gables' },
    { name: 'Coral Springs' },
    { name: 'Coral Terrace' },
    { name: 'Country Club' },
    { name: 'Country Walk' },
    { name: 'Crestview' },
    { name: 'Cutler' },
    { name: 'Cutler Ridge' },
    { name: 'Cypress Gardens' },
    { name: 'Cypress Lake' },
    { name: 'Dade City' },
    { name: 'Dania Beach' },
    { name: 'Davie' },
    { name: 'Daytona Beach' },
    { name: 'De Bary' },
    { name: 'De Land' },
    { name: 'Deerfield Beach' },
    { name: 'Delray Beach' },
    { name: 'Deltona' },
    { name: 'Destin' },
    { name: 'Doctor Phillips' },
    { name: 'Doral' },
    { name: 'Dunedin' },
    { name: 'East Lake' },
    { name: 'East Perrine' },
    { name: 'Edgewater' },
    { name: 'Eglin AFB' },
    { name: 'Egypt Lake-Leto' },
    { name: 'Elfers' },
    { name: 'Englewood' },
    { name: 'Ensley' },
    { name: 'Estero' },
    { name: 'Eustis' },
    { name: 'Fairview Shores' },
    { name: 'Fern Park' },
    { name: 'Fernandina Beach' },
    { name: 'Ferry Pass' },
    { name: 'Florida City' },
    { name: 'Florida Ridge' },
    { name: 'Forest City' },
    { name: 'Fort Lauderdale' },
    { name: 'Fort Myers' },
    { name: 'Fort Myers Beach' },
    { name: 'Fort Pierce' },
    { name: 'Fort Pierce North' },
    { name: 'Fort Walton Beach' },
    { name: 'Fountainbleau' },
    { name: 'Fruit Cove' },
    { name: 'Fruitville' },
    { name: 'Gainesville' },
    { name: 'Gibsonton' },
    { name: 'Gifford' },
    { name: 'Gladeview' },
    { name: 'Glenvar Heights' },
    { name: 'Golden Gate' },
    { name: 'Golden Glades' },
    { name: 'Golden Lakes' },
    { name: 'Goldenrod' },
    { name: 'Gonzalez' },
    { name: 'Goulds' },
    { name: 'Greater Carrollwood' },
    { name: 'Greater Northdale' },
    { name: 'Greater Sun Center' },
    { name: 'Greenacres' },
    { name: 'Gulf Gate Estates' },
    { name: 'Gulfport' },
    { name: 'Haines City' },
    { name: 'Hallandale' },
    { name: 'Hamptons at Boca Raton' },
    { name: 'Hernando' },
    { name: 'Hialeah' },
    { name: 'Hialeah Gardens' },
    { name: 'Hobe Sound' },
    { name: 'Holiday' },
    { name: 'Holly Hill' },
    { name: 'Hollywood' },
    { name: 'Homestead' },
    { name: 'Homosassa Springs' },
    { name: 'Hudson' },
    { name: 'Hunters Creek' },
    { name: 'Immokalee' },
    { name: 'Indian Harbour Beach' },
    { name: 'Inverness' },
    { name: 'Inwood' },
    { name: 'Iona' },
    { name: 'Islamorada' },
    { name: 'Ives Estates' },
    { name: 'Jacksonville' },
    { name: 'Jacksonville Beach' },
    { name: 'Jasmine Estates' },
    { name: 'Jensen Beach' },
    { name: 'Jupiter' },
    { name: 'Kendale Lakes' },
    { name: 'Kendall' },
    { name: 'Kendall West' },
    { name: 'Key Biscayne' },
    { name: 'Key Largo' },
    { name: 'Key West' },
    { name: 'Keystone' },
    { name: 'Kings Point' },
    { name: 'Kissimmee' },
    { name: 'Lady Lake' },
    { name: 'Lake Butter' },
    { name: 'Lake City' },
    { name: 'Lake Lorraine' },
    { name: 'Lake Lucerne' },
    { name: 'Lake Magdalene' },
    { name: 'Lake Mary' },
    { name: 'Lake Park' },
    { name: 'Lake Wales' },
    { name: 'Lake Worth' },
    { name: 'Lake Worth Corridor' },
    { name: 'Lakeland' },
    { name: 'Lakeland Highlands' },
    { name: 'Lakes by the Bay' },
    { name: 'Lakeside' },
    { name: 'Lakewood Park' },
    { name: 'Land O’ Lakes' },
    { name: 'Lantana' },
    { name: 'Largo' },
    { name: 'Lauderdale Lakes' },
    { name: 'Lauderhill' },
    { name: 'Laurel' },
    { name: 'Leesburg' },
    { name: 'Lehigh Acres' },
    { name: 'Leisure City' },
    { name: 'Lighthouse Point' },
    { name: 'Live Oak' },
    { name: 'Lockhart' },
    { name: 'Longboat Key' },
    { name: 'Longwood' },
    { name: 'Lutz' },
    { name: 'Lynn Haven' },
    { name: 'Maitland' },
    { name: 'Mango' },
    { name: 'Marathon' },
    { name: 'Marco Island' },
    { name: 'Margate' },
    { name: 'Marianna' },
    { name: 'McGregor' },
    { name: 'Meadow Woods' },
    { name: 'Medulla' },
    { name: 'Melbourne' },
    { name: 'Melrose Park' },
    { name: 'Memphis' },
    { name: 'Merritt Island' },
    { name: 'Miami' },
    { name: 'Miami Beach' },
    { name: 'Miami Lakes' },
    { name: 'Miami Shores' },
    { name: 'Miami Springs' },
    { name: 'Micco' },
    { name: 'Middleburg' },
    { name: 'Milton' },
    { name: 'Mims' },
    { name: 'Miramar' },
    { name: 'Mount Dora' },
    { name: 'Myrtle Grove' },
    { name: 'Naples' },
    { name: 'Naples Park' },
    { name: 'Neptune Beach' },
    { name: 'New Port Richey' },
    { name: 'New Port Richey East' },
    { name: 'New Smyrna Beach' },
    { name: 'Niceville' },
    { name: 'Norland' },
    { name: 'North Andrews Gardens' },
    { name: 'North Bay Village' },
    { name: 'North Fort Myers' },
    { name: 'North Lauderdale' },
    { name: 'North Miami' },
    { name: 'North Miami Beach' },
    { name: 'North Palm Beach' },
    { name: 'North Port' },
    { name: 'North Sarasota' },
    { name: 'Oak Ridge' },
    { name: 'Oakland Park' },
    { name: 'Ocala' },
    { name: 'Ocoee' },
    { name: 'Ojus' },
    { name: 'Oldsmar' },
    { name: 'Olympia Heights' },
    { name: 'Opa-locka' },
    { name: 'Opa-locka North' },
    { name: 'Orange City' },
    { name: 'Orange Park' },
    { name: 'Orlando' },
    { name: 'Orlovista' },
    { name: 'Ormond Beach' },
    { name: 'Ormond-By-The-Sea' },
    { name: 'Oviedo' },
    { name: 'Pace' },
    { name: 'Palatka' },
    { name: 'Palm Bay' },
    { name: 'Palm Beach' },
    { name: 'Palm Beach Gardens' },
    { name: 'Palm City' },
    { name: 'Palm Coast' },
    { name: 'Palm Harbor' },
    { name: 'Palm River-Clair Mel' },
    { name: 'Palm Springs' },
    { name: 'Palm Valley' },
    { name: 'Palmetto' },
    { name: 'Palmetto Estates' },
    { name: 'Panama City' },
    { name: 'Panama City Beach' },
    { name: 'Parkland' },
    { name: 'Pembroke Park' },
    { name: 'Pembroke Pines' },
    { name: 'Pensacola' },
    { name: 'Perry' },
    { name: 'Pine Castle' },
    { name: 'Pine Hills' },
    { name: 'Pinecrest' },
    { name: 'Pinellas Park' },
    { name: 'Pinewood' },
    { name: 'Plant City' },
    { name: 'Plantation' },
    { name: 'Poinciana' },
    { name: 'Pompano Beach' },
    { name: 'Pompano Beach Highlands' },
    { name: 'Port Charlotte' },
    { name: 'Port Orange' },
    { name: 'Port Salerno' },
    { name: 'Port St. John' },
    { name: 'Port St. Lucie' },
    { name: 'Princeton' },
    { name: 'Punta Gorda' },
    { name: 'Quincy' },
    { name: 'Richmond Heights' },
    { name: 'Richmond West' },
    { name: 'Riverview' },
    { name: 'Riviera Beach' },
    { name: 'Rockledge' },
    { name: 'Rotonda' },
    { name: 'Royal Palm Beach' },
    { name: 'Ruskin' },
    { name: 'Safety Harbor' },
    { name: 'San Carlos Park' },
    { name: 'Sandalfoot Cove' },
    { name: 'Sanford' },
    { name: 'Sanibel' },
    { name: 'Sarasota' },
    { name: 'Sarasota Springs' },
    { name: 'Satellite Beach' },
    { name: 'Scott Lake' },
    { name: 'Sebastian' },
    { name: 'Sebring' },
    { name: 'Seminole' },
    { name: 'Shady Hills' },
    { name: 'Siesta Key' },
    { name: 'Silver Springs Shores' },
    { name: 'South Bradenton' },
    { name: 'South Daytona' },
    { name: 'South Highpoint' },
    { name: 'South Miami' },
    { name: 'South Miami Heights' },
    { name: 'South Patrick Shores' },
    { name: 'South Venice' },
    { name: 'Southeast Arcadia' },
    { name: 'Southgate' },
    { name: 'Spring Hill' },
    { name: 'Springfield' },
    { name: 'St. Augustine' },
    { name: 'St. Cloud' },
    { name: 'St. Pete Beach' },
    { name: 'St. Petersburg' },
    { name: 'Stuart' },
    { name: 'Sugarmill Woods' },
    { name: 'Sunny Isles Beach' },
    { name: 'Sunrise' },
    { name: 'Sunset' },
    { name: 'Sweetwater' },
    { name: 'Tallahassee' },
    { name: 'Tamarac' },
    { name: 'Tamiami' },
    { name: 'Tampa' },
    { name: 'Tarpon Springs' },
    { name: 'Tavares' },
    { name: 'Temple Terrace' },
    { name: 'The Crossings' },
    { name: 'The Hammocks' },
    { name: 'The Villages' },
    { name: 'Thonotosassa' },
    { name: 'Three Lakes' },
    { name: 'Titusville' },
    { name: "Town 'n' Country" },
    { name: 'Treasure Island' },
    { name: 'Union Park' },
    { name: 'University' },
    { name: 'University Park' },
    { name: 'Upper Grand Lagoon' },
    { name: 'Valparaiso' },
    { name: 'Valrico' },
    { name: 'Venice' },
    { name: 'Venice Gardens' },
    { name: 'Vero Beach' },
    { name: 'Vero Beach South' },
    { name: 'Villas' },
    { name: 'Warrington' },
    { name: 'Wekiwa Springs' },
    { name: 'Wellington' },
    { name: 'West and East Lealman' },
    { name: 'West Little River' },
    { name: 'West Melbourne' },
    { name: 'West Palm Beach' },
    { name: 'West Pensacola' },
    { name: 'West Perrine' },
    { name: 'West Vero Corridor' },
    { name: 'Westchase' },
    { name: 'Westchester' },
    { name: 'Westgate-Belvedere Homes' },
    { name: 'Weston' },
    { name: 'Westview' },
    { name: 'Westwood Lakes' },
    { name: 'Williamsburg' },
    { name: 'Wilton Manors' },
    { name: 'Winston' },
    { name: 'Winter Garden' },
    { name: 'Winter Haven' },
    { name: 'Winter Park' },
    { name: 'Winter Springs' },
    { name: 'Wright' },
    { name: 'Yeehaw Junction' },
    { name: 'Yulee' },
    { name: 'Zephyrhills' },
  ],
  'georgia': [
    { name: 'Acworth' },
    { name: 'Albany' },
    { name: 'Alpharetta' },
    { name: 'Americus' },
    { name: 'Athens-Clarke County' },
    { name: 'Atlanta' },
    { name: 'Auburn' },
    { name: 'Augusta-Richmond County' },
    { name: 'Bainbridge' },
    { name: 'Belvedere Park' },
    { name: 'Brunswick' },
    { name: 'Buford' },
    { name: 'Cairo' },
    { name: 'Calhoun' },
    { name: 'Candler-McAfee' },
    { name: 'Canton' },
    { name: 'Carrollton' },
    { name: 'Cartersville' },
    { name: 'Cedartown' },
    { name: 'Chamblee' },
    { name: 'Clarkston' },
    { name: 'College Park' },
    { name: 'Columbus' },
    { name: 'Conley' },
    { name: 'Conyers' },
    { name: 'Cordele' },
    { name: 'Country Club Estates' },
    { name: 'Covington' },
    { name: 'Dalton' },
    { name: 'Decatur' },
    { name: 'Dock Junction' },
    { name: 'Doraville' },
    { name: 'Douglas' },
    { name: 'Douglasville' },
    { name: 'Druid Hills' },
    { name: 'Dublin' },
    { name: 'Duluth' },
    { name: 'Dunwoody' },
    { name: 'East Point' },
    { name: 'Eatonton' },
    { name: 'Evans' },
    { name: 'Fair Oaks' },
    { name: 'Fairview' },
    { name: 'Fayetteville' },
    { name: 'Fitzgerald' },
    { name: 'Forest Park' },
    { name: 'Fort Benning South' },
    { name: 'Fort Oglethorpe' },
    { name: 'Fort Stewart' },
    { name: 'Fort Valley' },
    { name: 'Gainesville' },
    { name: 'Garden City' },
    { name: 'Georgetown' },
    { name: 'Gresham Park' },
    { name: 'Griffin' },
    { name: 'Grovetown' },
    { name: 'Hapeville' },
    { name: 'Hinesville' },
    { name: 'Irondale' },
    { name: 'Jesup' },
    { name: 'Kennesaw' },
    { name: 'Kingsland' },
    { name: 'La Fayette' },
    { name: 'LaGrange' },
    { name: 'Lawrenceville' },
    { name: 'Lilburn' },
    { name: 'Mableton' },
    { name: 'Macon' },
    { name: 'Marietta' },
    { name: 'Martinez' },
    { name: 'McDonough' },
    { name: 'Milledgeville' },
    { name: 'Monroe' },
    { name: 'Moultrie' },
    { name: 'Mountain Park' },
    { name: 'Newnan' },
    { name: 'Norcross' },
    { name: 'North Atlanta' },
    { name: 'North Decatur' },
    { name: 'North Druid Hills' },
    { name: 'Panthersville' },
    { name: 'Peachtree City' },
    { name: 'Perry' },
    { name: 'Pooler' },
    { name: 'Powder Springs' },
    { name: 'Redan' },
    { name: 'Richmond Hill' },
    { name: 'Riverdale' },
    { name: 'Rome' },
    { name: 'Roswell' },
    { name: 'Sandersville' },
    { name: 'Sandy Springs' },
    { name: 'Savannah' },
    { name: 'Scottdale' },
    { name: 'Skidaway Island' },
    { name: 'Smyrna' },
    { name: 'Snellville' },
    { name: 'St. Marys' },
    { name: 'St. Simons' },
    { name: 'Statesboro' },
    { name: 'Stockbridge' },
    { name: 'Stone Mountain' },
    { name: 'Sugar Hill' },
    { name: 'Suwanee' },
    { name: 'Swainsboro' },
    { name: 'Thomaston' },
    { name: 'Thomasville' },
    { name: 'Thomson' },
    { name: 'Tifton' },
    { name: 'Toccoa' },
    { name: 'Tucker' },
    { name: 'Union City' },
    { name: 'Valdosta' },
    { name: 'Vidalia' },
    { name: 'Vinings' },
    { name: 'Warner Robins' },
    { name: 'Waycross' },
    { name: 'Wilmington Island' },
    { name: 'Winder' },
    { name: 'Woodstock' },
  ],
  'hawaii': [
    { name: 'Ahuimanu' },
    { name: 'Aiea' },
    { name: 'Ewa Beach' },
    { name: 'Haiku-Pauwela' },
    { name: 'Halawa' },
    { name: 'Hawaiian Paradise Park' },
    { name: 'Hilo' },
    { name: 'Holualoa' },
    { name: 'Honolulu' },
    { name: 'Kahului' },
    { name: 'Kailua' },
    { name: 'Kalaoa' },
    { name: 'Kaneohe' },
    { name: 'Kaneohe Station' },
    { name: 'Kapaa' },
    { name: 'Kihei' },
    { name: 'Lahaina' },
    { name: 'Makaha' },
    { name: 'Makakilo City' },
    { name: 'Makawao' },
    { name: 'Mililani Town' },
    { name: 'Nanakuli' },
    { name: 'Napili-Honokowai' },
    { name: 'Pearl City' },
    { name: 'Pukalani' },
    { name: 'Schofield Barracks' },
    { name: 'Village Park' },
    { name: 'Wahiawa' },
    { name: 'Waianae' },
    { name: 'Waihee-Waiehu' },
    { name: 'Wailuku' },
    { name: 'Waimalu' },
    { name: 'Waimea' },
    { name: 'Waipahu' },
    { name: 'Waipio' },
  ],
  'idaho': [
    { name: 'Ammon' },
    { name: 'Blackfoot' },
    { name: 'Boise City' },
    { name: 'Burley' },
    { name: 'Caldwell' },
    { name: 'Chubbuck' },
    { name: 'Coeur d’Alene' },
    { name: 'Eagle' },
    { name: 'Garden City' },
    { name: 'Hailey' },
    { name: 'Hayden' },
    { name: 'Idaho Falls' },
    { name: 'Jerome' },
    { name: 'Lewiston' },
    { name: 'Meridian' },
    { name: 'Moscow' },
    { name: 'Mountain Home' },
    { name: 'Mountain Home AFB' },
    { name: 'Nampa' },
    { name: 'Payette' },
    { name: 'Pocatello' },
    { name: 'Post Falls' },
    { name: 'Rexburg' },
    { name: 'Sandpoint' },
    { name: 'Twin Falls' },
  ],
  'illinois': [
    { name: 'Addison' },
    { name: 'Algonquin' },
    { name: 'Alsip' },
    { name: 'Alton' },
    { name: 'Antioch' },
    { name: 'Arlington Heights' },
    { name: 'Aurora' },
    { name: 'Barrington' },
    { name: 'Bartlett' },
    { name: 'Bartonville' },
    { name: 'Batavia' },
    { name: 'Beach Park' },
    { name: 'Belleville' },
    { name: 'Bellwood' },
    { name: 'Belvidere' },
    { name: 'Bensenville' },
    { name: 'Benton' },
    { name: 'Berwyn' },
    { name: 'Bethalto' },
    { name: 'Bloomingdale' },
    { name: 'Bloomington' },
    { name: 'Blue Island' },
    { name: 'Bolingbrook' },
    { name: 'Boulder Hill' },
    { name: 'Bourbonnais' },
    { name: 'Bradley' },
    { name: 'Bridgeview' },
    { name: 'Broadview' },
    { name: 'Brookfield' },
    { name: 'Buffalo Grove' },
    { name: 'Burbank' },
    { name: 'Burr Ridge' },
    { name: 'Cahokia' },
    { name: 'Calumet City' },
    { name: 'Calumet Park' },
    { name: 'Canton' },
    { name: 'Carbondale' },
    { name: 'Carol Stream' },
    { name: 'Carpentersville' },
    { name: 'Cary' },
    { name: 'Centralia' },
    { name: 'Champaign' },
    { name: 'Channahon' },
    { name: 'Charleston' },
    { name: 'Chatham' },
    { name: 'Chicago' },
    { name: 'Chicago Heights' },
    { name: 'Chicago Ridge' },
    { name: 'Cicero' },
    { name: 'Clarendon Hills' },
    { name: 'Clinton' },
    { name: 'Collinsville' },
    { name: 'Columbia' },
    { name: 'Country Club Hills' },
    { name: 'Crest Hill' },
    { name: 'Crestwood' },
    { name: 'Crete' },
    { name: 'Crystal Lake' },
    { name: 'Danville' },
    { name: 'Darien' },
    { name: 'Decatur' },
    { name: 'Deerfield' },
    { name: 'DeKalb' },
    { name: 'Des Plaines' },
    { name: 'Dixon' },
    { name: 'Dolton' },
    { name: 'Downers Grove' },
    { name: 'Du Quoin' },
    { name: 'East Alton' },
    { name: 'East Moline' },
    { name: 'East Peoria' },
    { name: 'East St. Louis' },
    { name: 'Edwardsville' },
    { name: 'Effingham' },
    { name: 'Elgin' },
    { name: 'Elk Grove Village' },
    { name: 'Elmhurst' },
    { name: 'Elmwood Park' },
    { name: 'Evanston' },
    { name: 'Evergreen Park' },
    { name: 'Fairview Heights' },
    { name: 'Flossmoor' },
    { name: 'Forest Park' },
    { name: 'Fox Lake' },
    { name: 'Frankfort' },
    { name: 'Frankfort Square' },
    { name: 'Franklin Park' },
    { name: 'Freeport' },
    { name: 'Gages Lake' },
    { name: 'Galesburg' },
    { name: 'Geneseo' },
    { name: 'Geneva' },
    { name: 'Glen Carbon' },
    { name: 'Glen Ellyn' },
    { name: 'Glencoe' },
    { name: 'Glendale Heights' },
    { name: 'Glenview' },
    { name: 'Glenwood' },
    { name: 'Godfrey' },
    { name: 'Goodings Grove' },
    { name: 'Granite City' },
    { name: 'Grayslake' },
    { name: 'Greenville' },
    { name: 'Gurnee' },
    { name: 'Hanover Park' },
    { name: 'Harrisburg' },
    { name: 'Harvard' },
    { name: 'Harvey' },
    { name: 'Harwood Heights' },
    { name: 'Hawthorn Woods' },
    { name: 'Hazel Crest' },
    { name: 'Herrin' },
    { name: 'Hickory Hills' },
    { name: 'Highland' },
    { name: 'Highland Park' },
    { name: 'Hillside' },
    { name: 'Hinsdale' },
    { name: 'Hoffman Estates' },
    { name: 'Homewood' },
    { name: 'Inverness' },
    { name: 'Island Lake' },
    { name: 'Itasca' },
    { name: 'Jacksonville' },
    { name: 'Jerseyville' },
    { name: 'Joliet' },
    { name: 'Justice' },
    { name: 'Kankakee' },
    { name: 'Kewanee' },
    { name: 'La Grange' },
    { name: 'La Grange Park' },
    { name: 'La Salle' },
    { name: 'Lake Bluff' },
    { name: 'Lake Forest' },
    { name: 'Lake in the Hills' },
    { name: 'Lake Zurich' },
    { name: 'Lansing' },
    { name: 'Lemont' },
    { name: 'Libertyville' },
    { name: 'Lincoln' },
    { name: 'Lincolnshire' },
    { name: 'Lincolnwood' },
    { name: 'Lindenhurst' },
    { name: 'Lisle' },
    { name: 'Litchfield' },
    { name: 'Lockport' },
    { name: 'Lombard' },
    { name: 'Long Grove' },
    { name: 'Loves Park' },
    { name: 'Lynwood' },
    { name: 'Lyons' },
    { name: 'Machesney Park' },
    { name: 'Macomb' },
    { name: 'Manteno' },
    { name: 'Marengo' },
    { name: 'Marion' },
    { name: 'Markham' },
    { name: 'Matteson' },
    { name: 'Mattoon' },
    { name: 'Maywood' },
    { name: 'McHenry' },
    { name: 'Melrose Park' },
    { name: 'Mendota' },
    { name: 'Metropolis' },
    { name: 'Midlothian' },
    { name: 'Mokena' },
    { name: 'Moline' },
    { name: 'Monmouth' },
    { name: 'Morris' },
    { name: 'Morton' },
    { name: 'Morton Grove' },
    { name: 'Mount Carmel' },
    { name: 'Mount Prospect' },
    { name: 'Mount Vernon' },
    { name: 'Mundelein' },
    { name: 'Murphysboro' },
    { name: 'Naperville' },
    { name: 'New Lenox' },
    { name: 'Niles' },
    { name: 'Normal' },
    { name: 'Norridge' },
    { name: 'North Aurora' },
    { name: 'North Chicago' },
    { name: 'North Riverside' },
    { name: 'Northbrook' },
    { name: 'Northlake' },
    { name: 'O’Fallon' },
    { name: 'Oak Brook' },
    { name: 'Oak Forest' },
    { name: 'Oak Lawn' },
    { name: 'Oak Park' },
    { name: 'Olney' },
    { name: 'Orland Hills' },
    { name: 'Orland Park' },
    { name: 'Oswego' },
    { name: 'Ottawa' },
    { name: 'Palatine' },
    { name: 'Palos Heights' },
    { name: 'Palos Hills' },
    { name: 'Paris' },
    { name: 'Park City' },
    { name: 'Park Forest' },
    { name: 'Park Ridge' },
    { name: 'Pekin' },
    { name: 'Peoria' },
    { name: 'Peoria Heights' },
    { name: 'Peru' },
    { name: 'Plainfield' },
    { name: 'Pontiac' },
    { name: 'Princeton' },
    { name: 'Prospect Heights' },
    { name: 'Quincy' },
    { name: 'Rantoul' },
    { name: 'Richton Park' },
    { name: 'River Forest' },
    { name: 'River Grove' },
    { name: 'Riverdale' },
    { name: 'Riverside' },
    { name: 'Robbins' },
    { name: 'Robinson' },
    { name: 'Rochelle' },
    { name: 'Rock Falls' },
    { name: 'Rock Island' },
    { name: 'Rockford' },
    { name: 'Rolling Meadows' },
    { name: 'Romeoville' },
    { name: 'Roscoe' },
    { name: 'Roselle' },
    { name: 'Round Lake Beach' },
    { name: 'Round Lake Park' },
    { name: 'Salem' },
    { name: 'Sandwich' },
    { name: 'Sauk Village' },
    { name: 'Schaumburg' },
    { name: 'Schiller Park' },
    { name: 'Shiloh' },
    { name: 'Shorewood' },
    { name: 'Silvis' },
    { name: 'Skokie' },
    { name: 'South Elgin' },
    { name: 'South Holland' },
    { name: 'Springfield' },
    { name: 'St. Charles' },
    { name: 'Steger' },
    { name: 'Sterling' },
    { name: 'Stickney' },
    { name: 'Streamwood' },
    { name: 'Streator' },
    { name: 'Summit' },
    { name: 'Swansea' },
    { name: 'Sycamore' },
    { name: 'Taylorville' },
    { name: 'Tinley Park' },
    { name: 'Troy' },
    { name: 'University Park' },
    { name: 'Urbana' },
    { name: 'Vandalia' },
    { name: 'Vernon Hills' },
    { name: 'Villa Park' },
    { name: 'Warrenville' },
    { name: 'Washington' },
    { name: 'Waterloo' },
    { name: 'Wauconda' },
    { name: 'Waukegan' },
    { name: 'West Chicago' },
    { name: 'West Frankfort' },
    { name: 'Westchester' },
    { name: 'Western Springs' },
    { name: 'Westmont' },
    { name: 'Wheaton' },
    { name: 'Wheeling' },
    { name: 'Willowbrook' },
    { name: 'Wilmette' },
    { name: 'Winfield' },
    { name: 'Winnetka' },
    { name: 'Winthrop Harbor' },
    { name: 'Wonder Lake' },
    { name: 'Wood Dale' },
    { name: 'Wood River' },
    { name: 'Woodridge' },
    { name: 'Woodstock' },
    { name: 'Worth' },
    { name: 'Yorkville' },
    { name: 'Zion' },
  ],
  'indiana': [
    { name: 'Alexandria' },
    { name: 'Anderson' },
    { name: 'Angola' },
    { name: 'Auburn' },
    { name: 'Avon' },
    { name: 'Batesville' },
    { name: 'Bedford' },
    { name: 'Beech Grove' },
    { name: 'Bloomington' },
    { name: 'Bluffton' },
    { name: 'Boonville' },
    { name: 'Brazil' },
    { name: 'Brownsburg' },
    { name: 'Carmel' },
    { name: 'Cedar Lake' },
    { name: 'Chesterton' },
    { name: 'Clarksville' },
    { name: 'Columbia City' },
    { name: 'Columbus' },
    { name: 'Connersville' },
    { name: 'Crawfordsville' },
    { name: 'Crown Point' },
    { name: 'Danville' },
    { name: 'Decatur' },
    { name: 'Dyer' },
    { name: 'East Chicago' },
    { name: 'Elkhart' },
    { name: 'Elwood' },
    { name: 'Evansville' },
    { name: 'Fishers' },
    { name: 'Fort Wayne' },
    { name: 'Frankfort' },
    { name: 'Franklin' },
    { name: 'Gary' },
    { name: 'Goshen' },
    { name: 'Granger' },
    { name: 'Greencastle' },
    { name: 'Greenfield' },
    { name: 'Greensburg' },
    { name: 'Greenwood' },
    { name: 'Griffith' },
    { name: 'Hammond' },
    { name: 'Hartford City' },
    { name: 'Highland' },
    { name: 'Hobart' },
    { name: 'Huntington' },
    { name: 'Indianapolis' },
    { name: 'Jasper' },
    { name: 'Jeffersonville' },
    { name: 'Kendallville' },
    { name: 'Kokomo' },
    { name: 'La Porte' },
    { name: 'Lafayette' },
    { name: 'Lake Station' },
    { name: 'Lakes of the Four Seasons' },
    { name: 'Lawrence' },
    { name: 'Lebanon' },
    { name: 'Logansport' },
    { name: 'Lowell' },
    { name: 'Madison' },
    { name: 'Marion' },
    { name: 'Martinsville' },
    { name: 'Merrillville' },
    { name: 'Michigan City' },
    { name: 'Mishawaka' },
    { name: 'Mooresville' },
    { name: 'Mount Vernon' },
    { name: 'Muncie' },
    { name: 'Munster' },
    { name: 'Nappanee' },
    { name: 'New Albany' },
    { name: 'New Castle' },
    { name: 'New Haven' },
    { name: 'Noblesville' },
    { name: 'North Manchester' },
    { name: 'North Vernon' },
    { name: 'Peru' },
    { name: 'Plainfield' },
    { name: 'Plymouth' },
    { name: 'Portage' },
    { name: 'Portland' },
    { name: 'Princeton' },
    { name: 'Richmond' },
    { name: 'Rochester' },
    { name: 'Salem' },
    { name: 'Schererville' },
    { name: 'Scottsburg' },
    { name: 'Sellersburg' },
    { name: 'Seymour' },
    { name: 'Shelbyville' },
    { name: 'South Bend' },
    { name: 'Speedway' },
    { name: 'St. John' },
    { name: 'Tell City' },
    { name: 'Terre Haute' },
    { name: 'Valparaiso' },
    { name: 'Vincennes' },
    { name: 'Wabash' },
    { name: 'Warsaw' },
    { name: 'Washington' },
    { name: 'West Lafayette' },
    { name: 'Westfield' },
    { name: 'Zionsville' },
  ],
  'iowa': [
    { name: 'Altoona' },
    { name: 'Ames' },
    { name: 'Ankeny' },
    { name: 'Atlantic' },
    { name: 'Bettendorf' },
    { name: 'Boone' },
    { name: 'Burlington' },
    { name: 'Carroll' },
    { name: 'Cedar Falls' },
    { name: 'Cedar Rapids' },
    { name: 'Charles City' },
    { name: 'Clear Lake' },
    { name: 'Clinton' },
    { name: 'Clive' },
    { name: 'Coralville' },
    { name: 'Council Bluffs' },
    { name: 'Creston' },
    { name: 'Davenport' },
    { name: 'Decorah' },
    { name: 'Denison' },
    { name: 'Des Moines' },
    { name: 'Dubuque' },
    { name: 'Estherville' },
    { name: 'Fairfield' },
    { name: 'Fort Dodge' },
    { name: 'Fort Madison' },
    { name: 'Grinnell' },
    { name: 'Hiawatha' },
    { name: 'Independence' },
    { name: 'Indianola' },
    { name: 'Iowa City' },
    { name: 'Johnston' },
    { name: 'Keokuk' },
    { name: 'Knoxville' },
    { name: 'Le Mars' },
    { name: 'Maquoketa' },
    { name: 'Marion' },
    { name: 'Marshalltown' },
    { name: 'Mason City' },
    { name: 'Mount Pleasant' },
    { name: 'Muscatine' },
    { name: 'Nevada' },
    { name: 'Newton' },
    { name: 'Norwalk' },
    { name: 'Oelwein' },
    { name: 'Oskaloosa' },
    { name: 'Ottumwa' },
    { name: 'Pella' },
    { name: 'Perry' },
    { name: 'Red Oak' },
    { name: 'Sioux Center' },
    { name: 'Sioux City' },
    { name: 'Spencer' },
    { name: 'Storm Lake' },
    { name: 'Urbandale' },
    { name: 'Washington' },
    { name: 'Waterloo' },
    { name: 'Waverly' },
    { name: 'Webster City' },
    { name: 'West Des Moines' },
  ],
  'kansas': [
    { name: 'Abilene' },
    { name: 'Andover' },
    { name: 'Arkansas City' },
    { name: 'Atchison' },
    { name: 'Augusta' },
    { name: 'Bonner Springs' },
    { name: 'Chanute' },
    { name: 'Coffeyville' },
    { name: 'Derby' },
    { name: 'Dodge City' },
    { name: 'El Dorado' },
    { name: 'Emporia' },
    { name: 'Fort Riley North' },
    { name: 'Fort Scott' },
    { name: 'Garden City' },
    { name: 'Gardner' },
    { name: 'Great Bend' },
    { name: 'Hays' },
    { name: 'Haysville' },
    { name: 'Hutchinson' },
    { name: 'Independence' },
    { name: 'Iola' },
    { name: 'Junction City' },
    { name: 'Kansas City' },
    { name: 'Lansing' },
    { name: 'Lawrence' },
    { name: 'Leavenworth' },
    { name: 'Leawood' },
    { name: 'Lenexa' },
    { name: 'Liberal' },
    { name: 'Manhattan' },
    { name: 'McPherson' },
    { name: 'Merriam' },
    { name: 'Mission' },
    { name: 'Newton' },
    { name: 'Olathe' },
    { name: 'Ottawa' },
    { name: 'Overland Park' },
    { name: 'Parsons' },
    { name: 'Pittsburg' },
    { name: 'Prairie Village' },
    { name: 'Pratt' },
    { name: 'Roeland Park' },
    { name: 'Salina' },
    { name: 'Shawnee' },
    { name: 'Topeka' },
    { name: 'Wellington' },
    { name: 'Wichita' },
    { name: 'Winfield' },
  ],
  'kentucky': [
    { name: 'Alexandria' },
    { name: 'Ashland' },
    { name: 'Bardstown' },
    { name: 'Bellevue' },
    { name: 'Berea' },
    { name: 'Bowling Green' },
    { name: 'Buechel' },
    { name: 'Burlington' },
    { name: 'Campbellsville' },
    { name: 'Corbin' },
    { name: 'Covington' },
    { name: 'Cynthiana' },
    { name: 'Danville' },
    { name: 'Edgewood' },
    { name: 'Elizabethtown' },
    { name: 'Elsmere' },
    { name: 'Erlanger' },
    { name: 'Fairdale' },
    { name: 'Fern Creek' },
    { name: 'Flatwoods' },
    { name: 'Florence' },
    { name: 'Fort Campbell North' },
    { name: 'Fort Knox' },
    { name: 'Fort Mitchell' },
    { name: 'Fort Thomas' },
    { name: 'Frankfort' },
    { name: 'Franklin' },
    { name: 'Georgetown' },
    { name: 'Glasgow' },
    { name: 'Harrodsburg' },
    { name: 'Henderson' },
    { name: 'Highland Heights' },
    { name: 'Highview' },
    { name: 'Hillview' },
    { name: 'Hopkinsville' },
    { name: 'Independence' },
    { name: 'Jeffersontown' },
    { name: 'Lawrenceburg' },
    { name: 'Leitchfield' },
    { name: 'Lexington-Fayette' },
    { name: 'Louisville' },
    { name: 'Lyndon' },
    { name: 'Madisonville' },
    { name: 'Mayfield' },
    { name: 'Maysville' },
    { name: 'Middlesborough' },
    { name: 'Mount Washington' },
    { name: 'Murray' },
    { name: 'Newburg' },
    { name: 'Newport' },
    { name: 'Nicholasville' },
    { name: 'Oak Grove' },
    { name: 'Oakbrook' },
    { name: 'Okolona' },
    { name: 'Owensboro' },
    { name: 'Paducah' },
    { name: 'Paris' },
    { name: 'Pikeville' },
    { name: 'Pleasure Ridge Park' },
    { name: 'Princeton' },
    { name: 'Radcliff' },
    { name: 'Richmond' },
    { name: 'Russellville' },
    { name: 'Shelbyville' },
    { name: 'Shepherdsville' },
    { name: 'Shively' },
    { name: 'Somerset' },
    { name: 'St. Dennis' },
    { name: 'St. Matthews' },
    { name: 'Taylor Mill' },
    { name: 'Valley Station' },
    { name: 'Versailles' },
    { name: 'Villa Hills' },
    { name: 'Winchester' },
  ],
  'louisiana': [
    { name: 'Abbeville' },
    { name: 'Alexandria' },
    { name: 'Arabi' },
    { name: 'Baker' },
    { name: 'Bastrop' },
    { name: 'Baton Rouge' },
    { name: 'Bayou Cane' },
    { name: 'Belle Chasse' },
    { name: 'Bogalusa' },
    { name: 'Bossier City' },
    { name: 'Breaux Bridge' },
    { name: 'Bridge City' },
    { name: 'Brownsville-Bawcomville' },
    { name: 'Carencro' },
    { name: 'Chalmette' },
    { name: 'Claiborne' },
    { name: 'Covington' },
    { name: 'Crowley' },
    { name: 'De Ridder' },
    { name: 'Denham Springs' },
    { name: 'Destrehan' },
    { name: 'Donaldsonville' },
    { name: 'Eden Isle' },
    { name: 'Estelle' },
    { name: 'Eunice' },
    { name: 'Fort Polk South' },
    { name: 'Franklin' },
    { name: 'Galliano' },
    { name: 'Gardere' },
    { name: 'Gonzales' },
    { name: 'Gretna' },
    { name: 'Hammond' },
    { name: 'Harahan' },
    { name: 'Harvey' },
    { name: 'Houma' },
    { name: 'Jefferson' },
    { name: 'Jennings' },
    { name: 'Kenner' },
    { name: 'Lacombe' },
    { name: 'Lafayette' },
    { name: 'Lake Charles' },
    { name: 'Laplace' },
    { name: 'Larose' },
    { name: 'Leesville' },
    { name: 'Luling' },
    { name: 'Mandeville' },
    { name: 'Marrero' },
    { name: 'Meraux' },
    { name: 'Merrydale' },
    { name: 'Metairie' },
    { name: 'Minden' },
    { name: 'Monroe' },
    { name: 'Morgan City' },
    { name: 'Moss Bluff' },
    { name: 'Natchitoches' },
    { name: 'New Iberia' },
    { name: 'New Orleans' },
    { name: 'Oak Hills Place' },
    { name: 'Oakdale' },
    { name: 'Opelousas' },
    { name: 'Pineville' },
    { name: 'Plaquemine' },
    { name: 'Prien' },
    { name: 'Raceland' },
    { name: 'Rayne' },
    { name: 'Reserve' },
    { name: 'River Ridge' },
    { name: 'Ruston' },
    { name: 'Scott' },
    { name: 'Shenandoah' },
    { name: 'Shreveport' },
    { name: 'Slidell' },
    { name: 'St. Martinville' },
    { name: 'St. Rose' },
    { name: 'Sulphur' },
    { name: 'Tallulah' },
    { name: 'Terrytown' },
    { name: 'Thibodaux' },
    { name: 'Timberlane' },
    { name: 'Village St. George' },
    { name: 'Ville Platte' },
    { name: 'Violet' },
    { name: 'Waggaman' },
    { name: 'West Monroe' },
    { name: 'Westwego' },
    { name: 'Woodmere' },
    { name: 'Zachary' },
  ],
  'maine': [
    { name: 'Auburn' },
    { name: 'Augusta' },
    { name: 'Bangor' },
    { name: 'Bath' },
    { name: 'Belfast' },
    { name: 'Berwick' },
    { name: 'Biddeford' },
    { name: 'Brewer' },
    { name: 'Brunswick' },
    { name: 'Buxton' },
    { name: 'Cape Elizabeth' },
    { name: 'Caribou' },
    { name: 'Cumberland' },
    { name: 'Ellsworth' },
    { name: 'Fairfield' },
    { name: 'Falmouth' },
    { name: 'Farmington' },
    { name: 'Freeport' },
    { name: 'Gardiner' },
    { name: 'Gorham' },
    { name: 'Gray' },
    { name: 'Hampden' },
    { name: 'Houlton' },
    { name: 'Kennebunk' },
    { name: 'Kittery' },
    { name: 'Lewiston' },
    { name: 'Lisbon' },
    { name: 'Old Orchard Beach' },
    { name: 'Old Town' },
    { name: 'Orono' },
    { name: 'Portland' },
    { name: 'Presque Isle' },
    { name: 'Rockland' },
    { name: 'Rumford' },
    { name: 'Saco' },
    { name: 'Sanford' },
    { name: 'Scarborough' },
    { name: 'Skowhegan' },
    { name: 'South Berwick' },
    { name: 'South Portland' },
    { name: 'Standish' },
    { name: 'Topsham' },
    { name: 'Waterboro' },
    { name: 'Waterville' },
    { name: 'Wells' },
    { name: 'Westbrook' },
    { name: 'Windham' },
    { name: 'Winslow' },
    { name: 'Winthrop' },
    { name: 'Yarmouth' },
    { name: 'York' },
  ],
  'maryland': [
    { name: 'Aberdeen' },
    { name: 'Accokeek' },
    { name: 'Adelphi' },
    { name: 'Andrews AFB' },
    { name: 'Annapolis' },
    { name: 'Arbutus' },
    { name: 'Arnold' },
    { name: 'Aspen Hill' },
    { name: 'Ballenger Creek' },
    { name: 'Baltimore' },
    { name: 'Bel Air' },
    { name: 'Bel Air North' },
    { name: 'Bel Air South' },
    { name: 'Beltsville' },
    { name: 'Bennsville' },
    { name: 'Bethesda' },
    { name: 'Bladensburg' },
    { name: 'Bowie' },
    { name: 'Bowleys Quarters' },
    { name: 'Brooklyn Park' },
    { name: 'Burtonsville' },
    { name: 'California' },
    { name: 'Calverton' },
    { name: 'Cambridge' },
    { name: 'Camp Springs' },
    { name: 'Cape St. Claire' },
    { name: 'Carney' },
    { name: 'Catonsville' },
    { name: 'Chesapeake Ranch Estates-Drum Point' },
    { name: 'Cheverly' },
    { name: 'Chevy Chase' },
    { name: 'Chillum' },
    { name: 'Clinton' },
    { name: 'Cloverly' },
    { name: 'Cockeysville' },
    { name: 'Colesville' },
    { name: 'College Park' },
    { name: 'Columbia' },
    { name: 'Coral Hills' },
    { name: 'Crofton' },
    { name: 'Cumberland' },
    { name: 'Damascus' },
    { name: 'Darnestown' },
    { name: 'Dundalk' },
    { name: 'East Riverdale' },
    { name: 'Easton' },
    { name: 'Edgemere' },
    { name: 'Edgewood' },
    { name: 'Eldersburg' },
    { name: 'Elkridge' },
    { name: 'Elkton' },
    { name: 'Ellicott City' },
    { name: 'Essex' },
    { name: 'Fairland' },
    { name: 'Fallston' },
    { name: 'Ferndale' },
    { name: 'Forest Glen' },
    { name: 'Forestville' },
    { name: 'Fort Meade' },
    { name: 'Fort Washington' },
    { name: 'Frederick' },
    { name: 'Friendly' },
    { name: 'Frostburg' },
    { name: 'Gaithersburg' },
    { name: 'Garrison' },
    { name: 'Germantown' },
    { name: 'Glen Burnie' },
    { name: 'Glenarden' },
    { name: 'Glenn Dale' },
    { name: 'Greater Landover' },
    { name: 'Greater Upper Marlboro' },
    { name: 'Green Haven' },
    { name: 'Green Valley' },
    { name: 'Greenbelt' },
    { name: 'Hagerstown' },
    { name: 'Halfway' },
    { name: 'Havre de Grace' },
    { name: 'Hillcrest Heights' },
    { name: 'Hyattsville' },
    { name: 'Jessup' },
    { name: 'Joppatowne' },
    { name: 'Kemp Mill' },
    { name: 'Kettering' },
    { name: 'La Plata' },
    { name: 'Lake Arbor' },
    { name: 'Lake Shore' },
    { name: 'Langley Park' },
    { name: 'Lanham-Seabrook' },
    { name: 'Lansdowne-Baltimore Highlands' },
    { name: 'Largo' },
    { name: 'Laurel' },
    { name: 'Lexington Park' },
    { name: 'Linganore-Bartonsville' },
    { name: 'Linthicum' },
    { name: 'Lochearn' },
    { name: 'Londontowne' },
    { name: 'Lutherville-Timonium' },
    { name: 'Marlow Heights' },
    { name: 'Marlton' },
    { name: 'Maryland City' },
    { name: 'Mays Chapel' },
    { name: 'Middle River' },
    { name: 'Milford Mill' },
    { name: 'Mitchellville' },
    { name: 'Montgomery Village' },
    { name: 'Mount Airy' },
    { name: 'Mount Rainier' },
    { name: 'New Carrollton' },
    { name: 'North Bethesda' },
    { name: 'North Kensington' },
    { name: 'North Laurel' },
    { name: 'North Potomac' },
    { name: 'Ocean City' },
    { name: 'Ocean Pines' },
    { name: 'Odenton' },
    { name: 'Olney' },
    { name: 'Overlea' },
    { name: 'Owings Mills' },
    { name: 'Oxon Hill-Glassmanor' },
    { name: 'Parkville' },
    { name: 'Parole' },
    { name: 'Pasadena' },
    { name: 'Perry Hall' },
    { name: 'Pikesville' },
    { name: 'Potomac' },
    { name: 'Randallstown' },
    { name: 'Redland' },
    { name: 'Reisterstown' },
    { name: 'Riverdale Park' },
    { name: 'Riverside' },
    { name: 'Riviera Beach' },
    { name: 'Rockville' },
    { name: 'Rosaryville' },
    { name: 'Rosedale' },
    { name: 'Rossmoor' },
    { name: 'Rossville' },
    { name: 'Salisbury' },
    { name: 'Savage-Guilford' },
    { name: 'Severn' },
    { name: 'Severna Park' },
    { name: 'Silver Spring' },
    { name: 'South Gate' },
    { name: 'South Kensington' },
    { name: 'South Laurel' },
    { name: 'St. Charles' },
    { name: 'Suitland-Silver Hill' },
    { name: 'Takoma Park' },
    { name: 'Temple Hills' },
    { name: 'Towson' },
    { name: 'Travilah' },
    { name: 'Waldorf' },
    { name: 'Walker Mill' },
    { name: 'Westminster' },
    { name: 'Wheaton-Glenmont' },
    { name: 'White Marsh' },
    { name: 'White Oak' },
    { name: 'Woodlawn' },
    { name: 'Woodmore' },
  ],
  'massachusetts': [
    { name: 'Abington' },
    { name: 'Acton' },
    { name: 'Acushnet' },
    { name: 'Adams' },
    { name: 'Agawam' },
    { name: 'Amesbury' },
    { name: 'Amherst' },
    { name: 'Amherst Center' },
    { name: 'Andover' },
    { name: 'Arlington' },
    { name: 'Ashland' },
    { name: 'Athol' },
    { name: 'Attleboro' },
    { name: 'Auburn' },
    { name: 'Ayer' },
    { name: 'Barnstable Town' },
    { name: 'Bedford' },
    { name: 'Belchertown' },
    { name: 'Bellingham' },
    { name: 'Belmont' },
    { name: 'Beverly' },
    { name: 'Billerica' },
    { name: 'Blackstone' },
    { name: 'Boston' },
    { name: 'Bourne' },
    { name: 'Boxford' },
    { name: 'Braintree' },
    { name: 'Brewster' },
    { name: 'Bridgewater' },
    { name: 'Brockton' },
    { name: 'Brookline' },
    { name: 'Burlington' },
    { name: 'Cambridge' },
    { name: 'Canton' },
    { name: 'Carver' },
    { name: 'Charlton' },
    { name: 'Chatham' },
    { name: 'Chelmsford' },
    { name: 'Chelsea' },
    { name: 'Chicopee' },
    { name: 'Clinton' },
    { name: 'Cochituate' },
    { name: 'Cohasset' },
    { name: 'Concord' },
    { name: 'Dalton' },
    { name: 'Danvers' },
    { name: 'Dartmouth' },
    { name: 'Dedham' },
    { name: 'Dennis' },
    { name: 'Dighton' },
    { name: 'Douglas' },
    { name: 'Dracut' },
    { name: 'Dudley' },
    { name: 'Duxbury' },
    { name: 'East Bridgewater' },
    { name: 'East Falmouth' },
    { name: 'East Longmeadow' },
    { name: 'Easthampton' },
    { name: 'Easton' },
    { name: 'Everett' },
    { name: 'Fairhaven' },
    { name: 'Fall River' },
    { name: 'Falmouth' },
    { name: 'Fitchburg' },
    { name: 'Foxborough' },
    { name: 'Framingham' },
    { name: 'Franklin' },
    { name: 'Freetown' },
    { name: 'Gardner' },
    { name: 'Georgetown' },
    { name: 'Gloucester' },
    { name: 'Grafton' },
    { name: 'Granby' },
    { name: 'Great Barrington' },
    { name: 'Greenfield' },
    { name: 'Groton' },
    { name: 'Groveland' },
    { name: 'Halifax' },
    { name: 'Hamilton' },
    { name: 'Hanover' },
    { name: 'Hanson' },
    { name: 'Harwich' },
    { name: 'Haverhill' },
    { name: 'Hingham' },
    { name: 'Holbrook' },
    { name: 'Holden' },
    { name: 'Holliston' },
    { name: 'Holyoke' },
    { name: 'Hopkinton' },
    { name: 'Hudson' },
    { name: 'Hull' },
    { name: 'Ipswich' },
    { name: 'Kingston' },
    { name: 'Lakeville' },
    { name: 'Lancaster' },
    { name: 'Lawrence' },
    { name: 'Leicester' },
    { name: 'Leominster' },
    { name: 'Lexington' },
    { name: 'Lincoln' },
    { name: 'Littleton' },
    { name: 'Longmeadow' },
    { name: 'Lowell' },
    { name: 'Ludlow' },
    { name: 'Lunenburg' },
    { name: 'Lynn' },
    { name: 'Lynnfield' },
    { name: 'Malden' },
    { name: 'Mansfield' },
    { name: 'Mansfield Center' },
    { name: 'Marblehead' },
    { name: 'Marlborough' },
    { name: 'Marshfield' },
    { name: 'Mashpee' },
    { name: 'Mattapoisett' },
    { name: 'Maynard' },
    { name: 'Medfield' },
    { name: 'Medford' },
    { name: 'Medway' },
    { name: 'Melrose' },
    { name: 'Merrimac' },
    { name: 'Methuen' },
    { name: 'Middleborough' },
    { name: 'Middleborough Center' },
    { name: 'Middleton' },
    { name: 'Milford' },
    { name: 'Millbury' },
    { name: 'Millis' },
    { name: 'Milton' },
    { name: 'Monson' },
    { name: 'Montague' },
    { name: 'Nantucket' },
    { name: 'Natick' },
    { name: 'Needham' },
    { name: 'New Bedford' },
    { name: 'Newbury' },
    { name: 'Newburyport' },
    { name: 'Newton' },
    { name: 'Norfolk' },
    { name: 'North Adams' },
    { name: 'North Amherst' },
    { name: 'North Andover' },
    { name: 'North Attleborough' },
    { name: 'North Attleborough Center' },
    { name: 'North Reading' },
    { name: 'Northampton' },
    { name: 'Northborough' },
    { name: 'Northbridge' },
    { name: 'Norton' },
    { name: 'Norwell' },
    { name: 'Norwood' },
    { name: 'Orange' },
    { name: 'Orleans' },
    { name: 'Oxford' },
    { name: 'Palmer' },
    { name: 'Peabody' },
    { name: 'Pembroke' },
    { name: 'Pepperell' },
    { name: 'Pinehurst' },
    { name: 'Pittsfield' },
    { name: 'Plainville' },
    { name: 'Plymouth' },
    { name: 'Quincy' },
    { name: 'Randolph' },
    { name: 'Raynham' },
    { name: 'Reading' },
    { name: 'Rehoboth' },
    { name: 'Revere' },
    { name: 'Rockland' },
    { name: 'Rockport' },
    { name: 'Rutland' },
    { name: 'Salem' },
    { name: 'Salisbury' },
    { name: 'Sandwich' },
    { name: 'Saugus' },
    { name: 'Scituate' },
    { name: 'Seekonk' },
    { name: 'Sharon' },
    { name: 'Shirley' },
    { name: 'Shrewsbury' },
    { name: 'Somerset' },
    { name: 'Somerville' },
    { name: 'South Hadley' },
    { name: 'South Yarmouth' },
    { name: 'Southborough' },
    { name: 'Southbridge' },
    { name: 'Southwick' },
    { name: 'Spencer' },
    { name: 'Springfield' },
    { name: 'Sterling' },
    { name: 'Stoneham' },
    { name: 'Stoughton' },
    { name: 'Sturbridge' },
    { name: 'Sudbury' },
    { name: 'Sutton' },
    { name: 'Swampscott' },
    { name: 'Swansea' },
    { name: 'Taunton' },
    { name: 'Templeton' },
    { name: 'Tewksbury' },
    { name: 'Topsfield' },
    { name: 'Townsend' },
    { name: 'Tyngsborough' },
    { name: 'Uxbridge' },
    { name: 'Wakefield' },
    { name: 'Walpole' },
    { name: 'Waltham' },
    { name: 'Ware' },
    { name: 'Wareham' },
    { name: 'Watertown' },
    { name: 'Wayland' },
    { name: 'Webster' },
    { name: 'Wellesley' },
    { name: 'West Boylston' },
    { name: 'West Bridgewater' },
    { name: 'West Springfield' },
    { name: 'West Yarmouth' },
    { name: 'Westborough' },
    { name: 'Westfield' },
    { name: 'Westford' },
    { name: 'Westminster' },
    { name: 'Weston' },
    { name: 'Westport' },
    { name: 'Westwood' },
    { name: 'Weymouth' },
    { name: 'Whitinsville' },
    { name: 'Whitman' },
    { name: 'Wilbraham' },
    { name: 'Williamstown' },
    { name: 'Wilmington' },
    { name: 'Winchendon' },
    { name: 'Winchester' },
    { name: 'Winthrop' },
    { name: 'Woburn' },
    { name: 'Worcester' },
    { name: 'Wrentham' },
    { name: 'Yarmouth' },
  ],
  'michigan': [
    { name: 'Adrian' },
    { name: 'Albion' },
    { name: 'Allen Park' },
    { name: 'Allendale' },
    { name: 'Alma' },
    { name: 'Alpena' },
    { name: 'Ann Arbor' },
    { name: 'Auburn Hills' },
    { name: 'Battle Creek' },
    { name: 'Bay City' },
    { name: 'Beecher' },
    { name: 'Benton Harbor' },
    { name: 'Berkley' },
    { name: 'Beverly Hills' },
    { name: 'Big Rapids' },
    { name: 'Birmingham' },
    { name: 'Bloomfield Township' },
    { name: 'Bridgeport' },
    { name: 'Brighton' },
    { name: 'Buena Vista' },
    { name: 'Burton' },
    { name: 'Cadillac' },
    { name: 'Canton' },
    { name: 'Carrollton' },
    { name: 'Center Line' },
    { name: 'Charlotte' },
    { name: 'Clawson' },
    { name: 'Clinton' },
    { name: 'Coldwater' },
    { name: 'Comstock Park' },
    { name: 'Cutlerville' },
    { name: 'Dearborn' },
    { name: 'Dearborn Heights' },
    { name: 'Detroit' },
    { name: 'Dowagiac' },
    { name: 'East Grand Rapids' },
    { name: 'East Lansing' },
    { name: 'Eastpointe' },
    { name: 'Eastwood' },
    { name: 'Ecorse' },
    { name: 'Escanaba' },
    { name: 'Fair Plain' },
    { name: 'Farmington' },
    { name: 'Farmington Hills' },
    { name: 'Fenton' },
    { name: 'Ferndale' },
    { name: 'Flat Rock' },
    { name: 'Flint' },
    { name: 'Flushing' },
    { name: 'Forest Hills' },
    { name: 'Fraser' },
    { name: 'Garden City' },
    { name: 'Grand Blanc' },
    { name: 'Grand Haven' },
    { name: 'Grand Ledge' },
    { name: 'Grand Rapids' },
    { name: 'Grandville' },
    { name: 'Greenville' },
    { name: 'Grosse Ile' },
    { name: 'Grosse Pointe Farms' },
    { name: 'Grosse Pointe Park' },
    { name: 'Grosse Pointe Woods' },
    { name: 'Hamtramck' },
    { name: 'Harper Woods' },
    { name: 'Harrison' },
    { name: 'Haslett' },
    { name: 'Hastings' },
    { name: 'Hazel Park' },
    { name: 'Highland Park' },
    { name: 'Hillsdale' },
    { name: 'Holland' },
    { name: 'Holly' },
    { name: 'Holt' },
    { name: 'Houghton' },
    { name: 'Howell' },
    { name: 'Hudsonville' },
    { name: 'Huntington Woods' },
    { name: 'Inkster' },
    { name: 'Ionia' },
    { name: 'Iron Mountain' },
    { name: 'Ironwood' },
    { name: 'Ishpeming' },
    { name: 'Jackson' },
    { name: 'Jenison' },
    { name: 'Kalamazoo' },
    { name: 'Kentwood' },
    { name: 'Lambertville' },
    { name: 'Lansing' },
    { name: 'Lapeer' },
    { name: 'Lincoln Park' },
    { name: 'Livonia' },
    { name: 'Ludington' },
    { name: 'Madison Heights' },
    { name: 'Manistee' },
    { name: 'Marquette' },
    { name: 'Marshall' },
    { name: 'Marysville' },
    { name: 'Mason' },
    { name: 'Melvindale' },
    { name: 'Menominee' },
    { name: 'Midland' },
    { name: 'Milford' },
    { name: 'Monroe' },
    { name: 'Mount Clemens' },
    { name: 'Mount Pleasant' },
    { name: 'Muskegon' },
    { name: 'Muskegon Heights' },
    { name: 'New Baltimore' },
    { name: 'Niles' },
    { name: 'Northview' },
    { name: 'Northville' },
    { name: 'Norton Shores' },
    { name: 'Novi' },
    { name: 'Oak Park' },
    { name: 'Okemos' },
    { name: 'Owosso' },
    { name: 'Petoskey' },
    { name: 'Plymouth' },
    { name: 'Plymouth Township' },
    { name: 'Pontiac' },
    { name: 'Port Huron' },
    { name: 'Portage' },
    { name: 'Redford' },
    { name: 'River Rouge' },
    { name: 'Riverview' },
    { name: 'Rochester' },
    { name: 'Rochester Hills' },
    { name: 'Romulus' },
    { name: 'Roseville' },
    { name: 'Royal Oak' },
    { name: 'Saginaw' },
    { name: 'Saginaw Township North' },
    { name: 'Saginaw Township South' },
    { name: 'Saline' },
    { name: 'Sault Ste. Marie' },
    { name: 'Shelby' },
    { name: 'Shields' },
    { name: 'South Lyon' },
    { name: 'South Monroe' },
    { name: 'Southfield' },
    { name: 'Southgate' },
    { name: 'St. Clair Shores' },
    { name: 'St. Johns' },
    { name: 'St. Joseph' },
    { name: 'Sterling Heights' },
    { name: 'Sturgis' },
    { name: 'Taylor' },
    { name: 'Tecumseh' },
    { name: 'Temperance' },
    { name: 'Three Rivers' },
    { name: 'Traverse City' },
    { name: 'Trenton' },
    { name: 'Troy' },
    { name: 'Walker' },
    { name: 'Walled Lake' },
    { name: 'Warren' },
    { name: 'Waterford' },
    { name: 'Waverly' },
    { name: 'Wayne' },
    { name: 'West Bloomfield Township' },
    { name: 'Westland' },
    { name: 'Westwood' },
    { name: 'Whitmore Lake' },
    { name: 'Wixom' },
    { name: 'Woodhaven' },
    { name: 'Wyandotte' },
    { name: 'Wyoming' },
    { name: 'Ypsilanti' },
  ],
  'minnesota': [
    { name: 'Albert Lea' },
    { name: 'Alexandria' },
    { name: 'Andover' },
    { name: 'Anoka' },
    { name: 'Apple Valley' },
    { name: 'Arden Hills' },
    { name: 'Austin' },
    { name: 'Bemidji' },
    { name: 'Big Lake' },
    { name: 'Blaine' },
    { name: 'Bloomington' },
    { name: 'Brainerd' },
    { name: 'Brooklyn Center' },
    { name: 'Brooklyn Park' },
    { name: 'Buffalo' },
    { name: 'Burnsville' },
    { name: 'Champlin' },
    { name: 'Chanhassen' },
    { name: 'Chaska' },
    { name: 'Cloquet' },
    { name: 'Columbia Heights' },
    { name: 'Coon Rapids' },
    { name: 'Cottage Grove' },
    { name: 'Crookston' },
    { name: 'Crystal' },
    { name: 'Detroit Lakes' },
    { name: 'Duluth' },
    { name: 'Eagan' },
    { name: 'East Bethel' },
    { name: 'East Grand Forks' },
    { name: 'Eden Prairie' },
    { name: 'Edina' },
    { name: 'Elk River' },
    { name: 'Fairmont' },
    { name: 'Faribault' },
    { name: 'Farmington' },
    { name: 'Fergus Falls' },
    { name: 'Forest Lake' },
    { name: 'Fridley' },
    { name: 'Golden Valley' },
    { name: 'Grand Rapids' },
    { name: 'Ham Lake' },
    { name: 'Hastings' },
    { name: 'Hermantown' },
    { name: 'Hibbing' },
    { name: 'Hopkins' },
    { name: 'Hugo' },
    { name: 'Hutchinson' },
    { name: 'International Falls' },
    { name: 'Inver Grove Heights' },
    { name: 'Lake Elmo' },
    { name: 'Lakeville' },
    { name: 'Lino Lakes' },
    { name: 'Litchfield' },
    { name: 'Little Canada' },
    { name: 'Little Falls' },
    { name: 'Mahtomedi' },
    { name: 'Mankato' },
    { name: 'Maple Grove' },
    { name: 'Maplewood' },
    { name: 'Marshall' },
    { name: 'Mendota Heights' },
    { name: 'Minneapolis' },
    { name: 'Minnetonka' },
    { name: 'Monticello' },
    { name: 'Moorhead' },
    { name: 'Mound' },
    { name: 'Mounds View' },
    { name: 'New Brighton' },
    { name: 'New Hope' },
    { name: 'New Ulm' },
    { name: 'North Branch' },
    { name: 'North Mankato' },
    { name: 'North St. Paul' },
    { name: 'Northfield' },
    { name: 'Oak Grove' },
    { name: 'Oakdale' },
    { name: 'Orono' },
    { name: 'Otsego' },
    { name: 'Owatonna' },
    { name: 'Plymouth' },
    { name: 'Prior Lake' },
    { name: 'Ramsey' },
    { name: 'Red Wing' },
    { name: 'Richfield' },
    { name: 'Robbinsdale' },
    { name: 'Rochester' },
    { name: 'Rosemount' },
    { name: 'Roseville' },
    { name: 'Sartell' },
    { name: 'Sauk Rapids' },
    { name: 'Savage' },
    { name: 'Shakopee' },
    { name: 'Shoreview' },
    { name: 'Shorewood' },
    { name: 'South St. Paul' },
    { name: 'Spring Lake Park' },
    { name: 'St. Anthony' },
    { name: 'St. Cloud' },
    { name: 'St. Louis Park' },
    { name: 'St. Michael' },
    { name: 'St. Paul' },
    { name: 'St. Peter' },
    { name: 'Stillwater' },
    { name: 'Thief River Falls' },
    { name: 'Vadnais Heights' },
    { name: 'Virginia' },
    { name: 'Waconia' },
    { name: 'Waite Park' },
    { name: 'Waseca' },
    { name: 'West St. Paul' },
    { name: 'White Bear Lake' },
    { name: 'Willmar' },
    { name: 'Winona' },
    { name: 'Woodbury' },
    { name: 'Worthington' },
  ],
  'mississippi': [
    { name: 'Aberdeen' },
    { name: 'Amory' },
    { name: 'Batesville' },
    { name: 'Bay St. Louis' },
    { name: 'Biloxi' },
    { name: 'Booneville' },
    { name: 'Brandon' },
    { name: 'Brookhaven' },
    { name: 'Byram' },
    { name: 'Canton' },
    { name: 'Clarksdale' },
    { name: 'Cleveland' },
    { name: 'Clinton' },
    { name: 'Columbia' },
    { name: 'Columbus' },
    { name: 'Corinth' },
    { name: 'D’Iberville' },
    { name: 'Gautier' },
    { name: 'Greenville' },
    { name: 'Greenwood' },
    { name: 'Grenada' },
    { name: 'Gulfport' },
    { name: 'Hattiesburg' },
    { name: 'Hernando' },
    { name: 'Holly Springs' },
    { name: 'Horn Lake' },
    { name: 'Indianola' },
    { name: 'Jackson' },
    { name: 'Kosciusko' },
    { name: 'Laurel' },
    { name: 'Long Beach' },
    { name: 'Louisville' },
    { name: 'Madison' },
    { name: 'McComb' },
    { name: 'Meridian' },
    { name: 'Moss Point' },
    { name: 'Natchez' },
    { name: 'New Albany' },
    { name: 'Ocean Springs' },
    { name: 'Olive Branch' },
    { name: 'Oxford' },
    { name: 'Pascagoula' },
    { name: 'Pass Christian' },
    { name: 'Pearl' },
    { name: 'Petal' },
    { name: 'Philadelphia' },
    { name: 'Picayune' },
    { name: 'Richland' },
    { name: 'Ridgeland' },
    { name: 'Senatobia' },
    { name: 'Southaven' },
    { name: 'St. Martin' },
    { name: 'Starkville' },
    { name: 'Tupelo' },
    { name: 'Vicksburg' },
    { name: 'Waveland' },
    { name: 'West Hattiesburg' },
    { name: 'West Point' },
    { name: 'Yazoo City' },
  ],
  'missouri': [
    { name: 'Affton' },
    { name: 'Arnold' },
    { name: 'Aurora' },
    { name: 'Ballwin' },
    { name: 'Barnhart' },
    { name: 'Bellefontaine Neighbors' },
    { name: 'Belton' },
    { name: 'Berkeley' },
    { name: 'Black Jack' },
    { name: 'Blue Springs' },
    { name: 'Bolivar' },
    { name: 'Boonville' },
    { name: 'Branson' },
    { name: 'Brentwood' },
    { name: 'Bridgeton' },
    { name: 'Cameron' },
    { name: 'Cape Girardeau' },
    { name: 'Carthage' },
    { name: 'Caruthersville' },
    { name: 'Chesterfield' },
    { name: 'Chillicothe' },
    { name: 'Clayton' },
    { name: 'Clinton' },
    { name: 'Columbia' },
    { name: 'Concord' },
    { name: 'Crestwood' },
    { name: 'Creve Coeur' },
    { name: 'De Soto' },
    { name: 'Des Peres' },
    { name: 'Dexter' },
    { name: 'Ellisville' },
    { name: 'Eureka' },
    { name: 'Excelsior Springs' },
    { name: 'Farmington' },
    { name: 'Ferguson' },
    { name: 'Festus' },
    { name: 'Florissant' },
    { name: 'Fort Leonard Wood' },
    { name: 'Fulton' },
    { name: 'Gladstone' },
    { name: 'Grandview' },
    { name: 'Hannibal' },
    { name: 'Harrisonville' },
    { name: 'Hazelwood' },
    { name: 'Independence' },
    { name: 'Jackson' },
    { name: 'Jefferson City' },
    { name: 'Jennings' },
    { name: 'Joplin' },
    { name: 'Kansas City' },
    { name: 'Kennett' },
    { name: 'Kirksville' },
    { name: 'Kirkwood' },
    { name: 'Ladue' },
    { name: 'Lake St. Louis' },
    { name: 'Lebanon' },
    { name: 'Lee’s Summit' },
    { name: 'Lemay' },
    { name: 'Liberty' },
    { name: 'Manchester' },
    { name: 'Maplewood' },
    { name: 'Marshall' },
    { name: 'Maryland Heights' },
    { name: 'Maryville' },
    { name: 'Mehlville' },
    { name: 'Mexico' },
    { name: 'Moberly' },
    { name: 'Monett' },
    { name: 'Murphy' },
    { name: 'Neosho' },
    { name: 'Nevada' },
    { name: 'Nixa' },
    { name: 'O’Fallon' },
    { name: 'Oakville' },
    { name: 'Olivette' },
    { name: 'Overland' },
    { name: 'Ozark' },
    { name: 'Park Hills' },
    { name: 'Perryville' },
    { name: 'Poplar Bluff' },
    { name: 'Raymore' },
    { name: 'Raytown' },
    { name: 'Republic' },
    { name: 'Richmond' },
    { name: 'Richmond Heights' },
    { name: 'Rolla' },
    { name: 'Sappington' },
    { name: 'Sedalia' },
    { name: 'Shrewsbury' },
    { name: 'Sikeston' },
    { name: 'Spanish Lake' },
    { name: 'Springfield' },
    { name: 'St. Ann' },
    { name: 'St. Charles' },
    { name: 'St. John' },
    { name: 'St. Joseph' },
    { name: 'St. Louis' },
    { name: 'St. Peters' },
    { name: 'Sullivan' },
    { name: 'Sunset Hills' },
    { name: 'Town and Country' },
    { name: 'Trenton' },
    { name: 'Troy' },
    { name: 'Union' },
    { name: 'University City' },
    { name: 'Valley Park' },
    { name: 'Warrensburg' },
    { name: 'Washington' },
    { name: 'Webb City' },
    { name: 'Webster Groves' },
    { name: 'Wentzville' },
    { name: 'West Plains' },
    { name: 'Wildwood' },
  ],
  'montana': [
    { name: 'Anaconda-Deer Lodge County' },
    { name: 'Billings' },
    { name: 'Bozeman' },
    { name: 'Butte-Silver Bow' },
    { name: 'Evergreen' },
    { name: 'Great Falls' },
    { name: 'Havre' },
    { name: 'Helena' },
    { name: 'Helena Valley Southeast' },
    { name: 'Helena Valley West Central' },
    { name: 'Kalispell' },
    { name: 'Laurel' },
    { name: 'Livingston' },
    { name: 'Miles City' },
    { name: 'Missoula' },
  ],
  'nebraska': [
    { name: 'Alliance' },
    { name: 'Beatrice' },
    { name: 'Bellevue' },
    { name: 'Blair' },
    { name: 'Chalco' },
    { name: 'Columbus' },
    { name: 'Crete' },
    { name: 'Elkhorn' },
    { name: 'Fremont' },
    { name: 'Gering' },
    { name: 'Grand Island' },
    { name: 'Hastings' },
    { name: 'Kearney' },
    { name: 'La Vista' },
    { name: 'Lexington' },
    { name: 'Lincoln' },
    { name: 'McCook' },
    { name: 'Nebraska City' },
    { name: 'Norfolk' },
    { name: 'North Platte' },
    { name: 'Offutt AFB' },
    { name: 'Omaha' },
    { name: 'Papillion' },
    { name: 'Plattsmouth' },
    { name: 'Ralston' },
    { name: 'Scottsbluff' },
    { name: 'Seward' },
    { name: 'Sidney' },
    { name: 'South Sioux City' },
    { name: 'York' },
  ],
  'nevada': [
    { name: 'Boulder City' },
    { name: 'Carson City' },
    { name: 'Elko' },
    { name: 'Enterprise' },
    { name: 'Fallon' },
    { name: 'Fernley' },
    { name: 'Gardnerville Ranchos' },
    { name: 'Henderson' },
    { name: 'Incline Village-Crystal Bay' },
    { name: 'Las Vegas' },
    { name: 'Laughlin' },
    { name: 'Lemmon Valley-Golden Valley' },
    { name: 'Mesquite' },
    { name: 'Nellis AFB' },
    { name: 'North Las Vegas' },
    { name: 'Pahrump' },
    { name: 'Paradise' },
    { name: 'Reno' },
    { name: 'Spanish Springs' },
    { name: 'Sparks' },
    { name: 'Spring Creek' },
    { name: 'Spring Valley' },
    { name: 'Sun Valley' },
    { name: 'Sunrise Manor' },
    { name: 'Whitney' },
    { name: 'Winchester' },
    { name: 'Winnemucca' },
  ],
  'new-hampshire': [
    { name: 'Amherst' },
    { name: 'Atkinson' },
    { name: 'Barrington' },
    { name: 'Bedford' },
    { name: 'Belmont' },
    { name: 'Berlin' },
    { name: 'Bow' },
    { name: 'Claremont' },
    { name: 'Concord' },
    { name: 'Conway' },
    { name: 'Derry' },
    { name: 'Dover' },
    { name: 'Durham' },
    { name: 'Exeter' },
    { name: 'Franklin' },
    { name: 'Gilford' },
    { name: 'Goffstown' },
    { name: 'Hampstead' },
    { name: 'Hampton' },
    { name: 'Hanover' },
    { name: 'Hollis' },
    { name: 'Hooksett' },
    { name: 'Hudson' },
    { name: 'Keene' },
    { name: 'Laconia' },
    { name: 'Lebanon' },
    { name: 'Litchfield' },
    { name: 'Londonderry' },
    { name: 'Manchester' },
    { name: 'Merrimack' },
    { name: 'Milford' },
    { name: 'Nashua' },
    { name: 'Newmarket' },
    { name: 'Newport' },
    { name: 'Pelham' },
    { name: 'Pembroke' },
    { name: 'Plaistow' },
    { name: 'Portsmouth' },
    { name: 'Raymond' },
    { name: 'Rochester' },
    { name: 'Salem' },
    { name: 'Seabrook' },
    { name: 'Somersworth' },
    { name: 'Stratham' },
    { name: 'Swanzey' },
    { name: 'Weare' },
    { name: 'Windham' },
    { name: 'Wolfeboro' },
  ],
  'new-jersey': [
    { name: 'Absecon' },
    { name: 'Allendale' },
    { name: 'Asbury Park' },
    { name: 'Ashland' },
    { name: 'Atlantic City' },
    { name: 'Audubon' },
    { name: 'Avenel' },
    { name: 'Barclay-Kingston' },
    { name: 'Barrington' },
    { name: 'Bayonne' },
    { name: 'Beachwood' },
    { name: 'Belleville' },
    { name: 'Bellmawr' },
    { name: 'Belmar' },
    { name: 'Bergenfield' },
    { name: 'Berkeley Heights' },
    { name: 'Berlin' },
    { name: 'Bernardsville' },
    { name: 'Bloomfield' },
    { name: 'Bloomingdale' },
    { name: 'Bogota' },
    { name: 'Boonton' },
    { name: 'Bound Brook' },
    { name: 'Bridgeton' },
    { name: 'Brigantine' },
    { name: 'Browns Mills' },
    { name: 'Budd Lake' },
    { name: 'Burlington' },
    { name: 'Butler' },
    { name: 'Caldwell' },
    { name: 'Camden' },
    { name: 'Carneys Point' },
    { name: 'Carteret' },
    { name: 'Cedar Grove' },
    { name: 'Chatham' },
    { name: 'Cherry Hill Mall' },
    { name: 'Clark' },
    { name: 'Clayton' },
    { name: 'Cliffside Park' },
    { name: 'Clifton' },
    { name: 'Closter' },
    { name: 'Collingswood' },
    { name: 'Colonia' },
    { name: 'Cranford' },
    { name: 'Cresskill' },
    { name: 'Crestwood Village' },
    { name: 'Dayton' },
    { name: 'Dover' },
    { name: 'Dumont' },
    { name: 'Dunellen' },
    { name: 'East Brunswick' },
    { name: 'East Orange' },
    { name: 'East Rutherford' },
    { name: 'Eatontown' },
    { name: 'Echelon' },
    { name: 'Edgewater' },
    { name: 'Edison' },
    { name: 'Elizabeth' },
    { name: 'Elmwood Park' },
    { name: 'Emerson' },
    { name: 'Englewood' },
    { name: 'Erlton-Ellisburg' },
    { name: 'Ewing' },
    { name: 'Fair Lawn' },
    { name: 'Fairfield' },
    { name: 'Fairview' },
    { name: 'Fanwood' },
    { name: 'Florence-Roebling' },
    { name: 'Florham Park' },
    { name: 'Fords' },
    { name: 'Fort Dix' },
    { name: 'Fort Lee' },
    { name: 'Franklin Lakes' },
    { name: 'Freehold' },
    { name: 'Garfield' },
    { name: 'Glassboro' },
    { name: 'Glen Ridge' },
    { name: 'Glen Rock' },
    { name: 'Gloucester City' },
    { name: 'Greentree' },
    { name: 'Guttenberg' },
    { name: 'Hackensack' },
    { name: 'Hackettstown' },
    { name: 'Haddon Heights' },
    { name: 'Haddonfield' },
    { name: 'Haledon' },
    { name: 'Hammonton' },
    { name: 'Harrison' },
    { name: 'Hasbrouck Heights' },
    { name: 'Hawthorne' },
    { name: 'Highland Park' },
    { name: 'Hillsdale' },
    { name: 'Hillside' },
    { name: 'Hoboken' },
    { name: 'Holiday City-Berkeley' },
    { name: 'Hopatcong' },
    { name: 'Irvington' },
    { name: 'Iselin' },
    { name: 'Jamesburg' },
    { name: 'Jersey City' },
    { name: 'Keansburg' },
    { name: 'Kearny' },
    { name: 'Kendall Park' },
    { name: 'Kenilworth' },
    { name: 'Keyport' },
    { name: 'Kinnelon' },
    { name: 'Lake Mohawk' },
    { name: 'Lakewood' },
    { name: 'Laurence Harbor' },
    { name: 'Leisure Village West-Pine Lake Park' },
    { name: 'Leonia' },
    { name: 'Lincoln Park' },
    { name: 'Lincroft' },
    { name: 'Linden' },
    { name: 'Lindenwold' },
    { name: 'Linwood' },
    { name: 'Little Falls' },
    { name: 'Little Ferry' },
    { name: 'Little Silver' },
    { name: 'Livingston' },
    { name: 'Lodi' },
    { name: 'Long Branch' },
    { name: 'Lyndhurst' },
    { name: 'Madison' },
    { name: 'Madison Park' },
    { name: 'Manasquan' },
    { name: 'Manville' },
    { name: 'Maplewood' },
    { name: 'Margate City' },
    { name: 'Marlton' },
    { name: 'Matawan' },
    { name: 'Maywood' },
    { name: 'McGuire AFB' },
    { name: 'Mercerville-Hamilton Square' },
    { name: 'Metuchen' },
    { name: 'Middlesex' },
    { name: 'Midland Park' },
    { name: 'Millburn' },
    { name: 'Milltown' },
    { name: 'Millville' },
    { name: 'Montclair' },
    { name: 'Montvale' },
    { name: 'Moorestown-Lenola' },
    { name: 'Morganville' },
    { name: 'Morristown' },
    { name: 'Mountainside' },
    { name: 'Mystic Island' },
    { name: 'New Brunswick' },
    { name: 'New Milford' },
    { name: 'New Providence' },
    { name: 'Newark' },
    { name: 'Newton' },
    { name: 'North Arlington' },
    { name: 'North Brunswick Township' },
    { name: 'North Caldwell' },
    { name: 'North Haledon' },
    { name: 'North Plainfield' },
    { name: 'Northfield' },
    { name: 'Nutley' },
    { name: 'Oakland' },
    { name: 'Ocean Acres' },
    { name: 'Ocean City' },
    { name: 'Old Bridge' },
    { name: 'Oradell' },
    { name: 'Orange' },
    { name: 'Palisades Park' },
    { name: 'Palmyra' },
    { name: 'Paramus' },
    { name: 'Park Ridge' },
    { name: 'Passaic' },
    { name: 'Paterson' },
    { name: 'Paulsboro' },
    { name: 'Pennsauken' },
    { name: 'Pennsville' },
    { name: 'Perth Amboy' },
    { name: 'Phillipsburg' },
    { name: 'Pine Hill' },
    { name: 'Pitman' },
    { name: 'Plainfield' },
    { name: 'Pleasantville' },
    { name: 'Point Pleasant' },
    { name: 'Pompton Lakes' },
    { name: 'Princeton' },
    { name: 'Princeton Meadows' },
    { name: 'Rahway' },
    { name: 'Ramblewood' },
    { name: 'Ramsey' },
    { name: 'Raritan' },
    { name: 'Red Bank' },
    { name: 'Ridgefield' },
    { name: 'Ridgefield Park' },
    { name: 'Ridgewood' },
    { name: 'Ringwood' },
    { name: 'River Edge' },
    { name: 'River Vale' },
    { name: 'Rockaway' },
    { name: 'Roselle' },
    { name: 'Roselle Park' },
    { name: 'Rumson' },
    { name: 'Runnemede' },
    { name: 'Rutherford' },
    { name: 'Saddle Brook' },
    { name: 'Sayreville' },
    { name: 'Scotch Plains' },
    { name: 'Secaucus' },
    { name: 'Somers Point' },
    { name: 'Somerset' },
    { name: 'Somerville' },
    { name: 'South Amboy' },
    { name: 'South Orange' },
    { name: 'South Plainfield' },
    { name: 'South River' },
    { name: 'Spotswood' },
    { name: 'Springdale' },
    { name: 'Springfield' },
    { name: 'Stratford' },
    { name: 'Strathmore' },
    { name: 'Succasunna-Kenvil' },
    { name: 'Summit' },
    { name: 'Teaneck' },
    { name: 'Tenafly' },
    { name: 'Tinton Falls' },
    { name: 'Toms River' },
    { name: 'Totowa' },
    { name: 'Trenton' },
    { name: 'Twin Rivers' },
    { name: 'Union' },
    { name: 'Union Beach' },
    { name: 'Union City' },
    { name: 'Upper Saddle River' },
    { name: 'Ventnor City' },
    { name: 'Verona' },
    { name: 'Villas' },
    { name: 'Vineland' },
    { name: 'Waldwick' },
    { name: 'Wallington' },
    { name: 'Wanaque' },
    { name: 'Washington' },
    { name: 'Washington Township' },
    { name: 'Wayne' },
    { name: 'West Caldwell' },
    { name: 'West Freehold' },
    { name: 'West Long Branch' },
    { name: 'West Milford' },
    { name: 'West New York' },
    { name: 'West Orange' },
    { name: 'West Paterson' },
    { name: 'Westfield' },
    { name: 'Westwood' },
    { name: 'Wharton' },
    { name: 'White Horse' },
    { name: 'White Meadow Lake' },
    { name: 'Williamstown' },
    { name: 'Wood-Ridge' },
    { name: 'Woodbridge' },
    { name: 'Woodbury' },
    { name: 'Wyckoff' },
    { name: 'Yardville-Groveville' },
    { name: 'Yorketown' },
  ],
  'new-mexico': [
    { name: 'Alamogordo' },
    { name: 'Albuquerque' },
    { name: 'Anthony' },
    { name: 'Artesia' },
    { name: 'Aztec' },
    { name: 'Belen' },
    { name: 'Bernalillo' },
    { name: 'Bloomfield' },
    { name: 'Carlsbad' },
    { name: 'Chaparral' },
    { name: 'Clovis' },
    { name: 'Corrales' },
    { name: 'Deming' },
    { name: 'Espanola' },
    { name: 'Farmington' },
    { name: 'Gallup' },
    { name: 'Grants' },
    { name: 'Hobbs' },
    { name: 'Kirtland' },
    { name: 'Las Cruces' },
    { name: 'Las Vegas' },
    { name: 'Los Alamos' },
    { name: 'Los Lunas' },
    { name: 'Lovington' },
    { name: 'North Valley' },
    { name: 'Portales' },
    { name: 'Raton' },
    { name: 'Rio Rancho' },
    { name: 'Roswell' },
    { name: 'Ruidoso' },
    { name: 'Santa Fe' },
    { name: 'Shiprock' },
    { name: 'Silver City' },
    { name: 'Socorro' },
    { name: 'South Valley' },
    { name: 'Sunland Park' },
    { name: 'Truth or Consequences' },
    { name: 'White Rock' },
    { name: 'Zuni Pueblo' },
  ],
  'new-york': [
    { name: 'Airmont' },
    { name: 'Albany' },
    { name: 'Albion' },
    { name: 'Alden' },
    { name: 'Allegany' },
    { name: 'Altamont' },
    { name: 'Amherst' },
    { name: 'Amityville' },
    { name: 'Amsterdam' },
    { name: 'Arcadia' },
    { name: 'Arlington' },
    { name: 'Attica' },
    { name: 'Auburn' },
    { name: 'Aurora' },
    { name: 'Avon' },
    { name: 'Babylon' },
    { name: 'Baldwin' },
    { name: 'Baldwin Harbor' },
    { name: 'Baldwinsville' },
    { name: 'Ballston' },
    { name: 'Barton' },
    { name: 'Batavia' },
    { name: 'Bath' },
    { name: 'Bay Shore' },
    { name: 'Bayport' },
    { name: 'Bayville' },
    { name: 'Baywood' },
    { name: 'Beacon' },
    { name: 'Bedford' },
    { name: 'Beekman' },
    { name: 'Bellmore' },
    { name: 'Bethlehem' },
    { name: 'Bethpage' },
    { name: 'Big Flats' },
    { name: 'Binghamton' },
    { name: 'Blooming Grove' },
    { name: 'Bohemia' },
    { name: 'Boston' },
    { name: 'Brentwood' },
    { name: 'Briarcliff Manor' },
    { name: 'Brighton' },
    { name: 'Brockport' },
    { name: 'Bronxville' },
    { name: 'Brookhaven' },
    { name: 'Brunswick' },
    { name: 'Buffalo' },
    { name: 'Busti' },
    { name: 'Cairo' },
    { name: 'Camillus' },
    { name: 'Canandaigua' },
    { name: 'Canton' },
    { name: 'Carmel' },
    { name: 'Catskill' },
    { name: 'Cazenovia' },
    { name: 'Cedarhurst' },
    { name: 'Center Moriches' },
    { name: 'Centereach' },
    { name: 'Central Islip' },
    { name: 'Chappaqua' },
    { name: 'Cheektowaga' },
    { name: 'Chenango' },
    { name: 'Chester' },
    { name: 'Chestnut Ridge' },
    { name: 'Chili' },
    { name: 'Cicero' },
    { name: 'Clarence' },
    { name: 'Clarkson' },
    { name: 'Clarkstown' },
    { name: 'Claverack' },
    { name: 'Clay' },
    { name: 'Clifton Park' },
    { name: 'Cobleskill' },
    { name: 'Coeymans' },
    { name: 'Cohoes' },
    { name: 'Collins' },
    { name: 'Colonie' },
    { name: 'Commack' },
    { name: 'Concord' },
    { name: 'Congers' },
    { name: 'Copiague' },
    { name: 'Coram' },
    { name: 'Corning' },
    { name: 'Cornwall' },
    { name: 'Cortland' },
    { name: 'Cortlandt' },
    { name: 'Cortlandville' },
    { name: 'Coxsackie' },
    { name: 'Crawford' },
    { name: 'Croton-on-Hudson' },
    { name: 'De Witt' },
    { name: 'Deer Park' },
    { name: 'Deerpark' },
    { name: 'Delmar' },
    { name: 'Depew' },
    { name: 'Dix Hills' },
    { name: 'Dobbs Ferry' },
    { name: 'Dover' },
    { name: 'Dryden' },
    { name: 'Dunkirk' },
    { name: 'East Aurora' },
    { name: 'East Fishkill' },
    { name: 'East Glenville' },
    { name: 'East Greenbush' },
    { name: 'East Hampton' },
    { name: 'East Hills' },
    { name: 'East Islip' },
    { name: 'East Massapequa' },
    { name: 'East Meadow' },
    { name: 'East Northport' },
    { name: 'East Patchogue' },
    { name: 'East Rochester' },
    { name: 'East Rockaway' },
    { name: 'Eastchester' },
    { name: 'Eden' },
    { name: 'Elbridge' },
    { name: 'Ellicott' },
    { name: 'Elma' },
    { name: 'Elmira' },
    { name: 'Elmont' },
    { name: 'Elwood' },
    { name: 'Endicott' },
    { name: 'Endwell' },
    { name: 'Erwin' },
    { name: 'Esopus' },
    { name: 'Evans' },
    { name: 'Fairmount' },
    { name: 'Fallsburg' },
    { name: 'Farmingdale' },
    { name: 'Farmington' },
    { name: 'Farmingville' },
    { name: 'Fenton' },
    { name: 'Fishkill' },
    { name: 'Floral Park' },
    { name: 'Fort Ann' },
    { name: 'Fort Drum' },
    { name: 'Fort Salonga' },
    { name: 'Frankfort' },
    { name: 'Franklin Square' },
    { name: 'Fredonia' },
    { name: 'Freeport' },
    { name: 'Fulton' },
    { name: 'Garden City' },
    { name: 'Garden City Park' },
    { name: 'Gates' },
    { name: 'Gates-North Gates' },
    { name: 'Geddes' },
    { name: 'Geneseo' },
    { name: 'Geneva' },
    { name: 'German Flatts' },
    { name: 'Glen Cove' },
    { name: 'Glens Falls' },
    { name: 'Glens Falls North' },
    { name: 'Glenville' },
    { name: 'Gloversville' },
    { name: 'Goshen' },
    { name: 'Gouverneur' },
    { name: 'Granby' },
    { name: 'Grand Island' },
    { name: 'Granville' },
    { name: 'Great Neck' },
    { name: 'Great Neck Plaza' },
    { name: 'Greece' },
    { name: 'Greenburgh' },
    { name: 'Greenfield' },
    { name: 'Greenlawn' },
    { name: 'Greenville' },
    { name: 'Guilderland' },
    { name: 'Halfmoon' },
    { name: 'Hamburg' },
    { name: 'Hamlin' },
    { name: 'Hampton Bays' },
    { name: 'Hanover' },
    { name: 'Harrison' },
    { name: 'Hartsdale' },
    { name: 'Hastings' },
    { name: 'Hastings-on-Hudson' },
    { name: 'Hauppauge' },
    { name: 'Haverstraw' },
    { name: 'Hempstead' },
    { name: 'Henrietta' },
    { name: 'Herkimer' },
    { name: 'Hewlett' },
    { name: 'Hicksville' },
    { name: 'Highlands' },
    { name: 'Hillcrest' },
    { name: 'Holbrook' },
    { name: 'Holtsville' },
    { name: 'Homer' },
    { name: 'Hoosick' },
    { name: 'Hornell' },
    { name: 'Horseheads' },
    { name: 'Hudson' },
    { name: 'Hudson Falls' },
    { name: 'Huntington' },
    { name: 'Huntington Station' },
    { name: 'Hurley' },
    { name: 'Hyde Park' },
    { name: 'Ilion' },
    { name: 'Inwood' },
    { name: 'Irondequoit' },
    { name: 'Irvington' },
    { name: 'Islip' },
    { name: 'Ithaca' },
    { name: 'Jamestown' },
    { name: 'Jefferson Valley-Yorktown' },
    { name: 'Jericho' },
    { name: 'Johnson City' },
    { name: 'Johnstown' },
    { name: 'Kenmore' },
    { name: 'Kent' },
    { name: 'Kinderhook' },
    { name: 'Kings Park' },
    { name: 'Kingsbury' },
    { name: 'Kingston' },
    { name: 'Kirkland' },
    { name: 'Kiryas Joel' },
    { name: 'La Grange' },
    { name: 'Lackawanna' },
    { name: 'Lake Carmel' },
    { name: 'Lake Grove' },
    { name: 'Lake Ronkonkoma' },
    { name: 'Lancaster' },
    { name: 'Lansing' },
    { name: 'Larchmont' },
    { name: 'Lawrence' },
    { name: 'Le Ray' },
    { name: 'Le Roy' },
    { name: 'Lee' },
    { name: 'Lenox' },
    { name: 'Levittown' },
    { name: 'Lewisboro' },
    { name: 'Lewiston' },
    { name: 'Liberty' },
    { name: 'Lindenhurst' },
    { name: 'Livonia' },
    { name: 'Lloyd' },
    { name: 'Lockport' },
    { name: 'Long Beach' },
    { name: 'Lynbrook' },
    { name: 'Lysander' },
    { name: 'Macedon' },
    { name: 'Mahopac' },
    { name: 'Malone' },
    { name: 'Malta' },
    { name: 'Malverne' },
    { name: 'Mamakating' },
    { name: 'Mamaroneck' },
    { name: 'Manchester' },
    { name: 'Manhasset' },
    { name: 'Manlius' },
    { name: 'Manorhaven' },
    { name: 'Manorville' },
    { name: 'Marcellus' },
    { name: 'Marcy' },
    { name: 'Marlborough' },
    { name: 'Massapequa' },
    { name: 'Massapequa Park' },
    { name: 'Massena' },
    { name: 'Mastic' },
    { name: 'Mastic Beach' },
    { name: 'Mattydale' },
    { name: 'Mayfield' },
    { name: 'Mechanicstown' },
    { name: 'Medford' },
    { name: 'Medina' },
    { name: 'Melville' },
    { name: 'Mendon' },
    { name: 'Merrick' },
    { name: 'Middle Island' },
    { name: 'Middletown' },
    { name: 'Miller Place' },
    { name: 'Milo' },
    { name: 'Milton' },
    { name: 'Mineola' },
    { name: 'Monroe' },
    { name: 'Monsey' },
    { name: 'Montgomery' },
    { name: 'Monticello' },
    { name: 'Moreau' },
    { name: 'Mount Hope' },
    { name: 'Mount Ivy' },
    { name: 'Mount Kisco' },
    { name: 'Mount Pleasant' },
    { name: 'Mount Sinai' },
    { name: 'Mount Vernon' },
    { name: 'Murray' },
    { name: 'Nanuet' },
    { name: 'Nesconset' },
    { name: 'New Cassel' },
    { name: 'New Castle' },
    { name: 'New City' },
    { name: 'New Hartford' },
    { name: 'New Hyde Park' },
    { name: 'New Paltz' },
    { name: 'New Rochelle' },
    { name: 'New Scotland' },
    { name: 'New Windsor' },
    { name: 'New York' },
    { name: 'Newark' },
    { name: 'Newburgh' },
    { name: 'Newfane' },
    { name: 'Newstead' },
    { name: 'Niagara' },
    { name: 'Niagara Falls' },
    { name: 'Niskayuna' },
    { name: 'North Amityville' },
    { name: 'North Babylon' },
    { name: 'North Bay Shore' },
    { name: 'North Bellmore' },
    { name: 'North Bellport' },
    { name: 'North Castle' },
    { name: 'North Elba' },
    { name: 'North Greenbush' },
    { name: 'North Hempstead' },
    { name: 'North Lindenhurst' },
    { name: 'North Massapequa' },
    { name: 'North Merrick' },
    { name: 'North New Hyde Park' },
    { name: 'North Patchogue' },
    { name: 'North Syracuse' },
    { name: 'North Tonawanda' },
    { name: 'North Valley Stream' },
    { name: 'North Wantagh' },
    { name: 'Northport' },
    { name: 'Norwich' },
    { name: 'Nyack' },
    { name: 'Oakdale' },
    { name: 'Oceanside' },
    { name: 'Ogden' },
    { name: 'Ogdensburg' },
    { name: 'Olean' },
    { name: 'Oneida' },
    { name: 'Oneonta' },
    { name: 'Onondaga' },
    { name: 'Ontario' },
    { name: 'Orange Lake' },
    { name: 'Orangetown' },
    { name: 'Orchard Park' },
    { name: 'Ossining' },
    { name: 'Oswego' },
    { name: 'Owego' },
    { name: 'Oyster Bay' },
    { name: 'Palmyra' },
    { name: 'Parma' },
    { name: 'Patchogue' },
    { name: 'Patterson' },
    { name: 'Pawling' },
    { name: 'Pearl River' },
    { name: 'Peekskill' },
    { name: 'Pelham' },
    { name: 'Pendleton' },
    { name: 'Penfield' },
    { name: 'Perinton' },
    { name: 'Perry' },
    { name: 'Peru' },
    { name: 'Phelps' },
    { name: 'Philipstown' },
    { name: 'Pittsford' },
    { name: 'Plainedge' },
    { name: 'Plainview' },
    { name: 'Plattekill' },
    { name: 'Plattsburgh' },
    { name: 'Pleasant Valley' },
    { name: 'Pleasantville' },
    { name: 'Pomfret' },
    { name: 'Pompey' },
    { name: 'Port Chester' },
    { name: 'Port Jefferson' },
    { name: 'Port Jefferson Station' },
    { name: 'Port Jervis' },
    { name: 'Port Washington' },
    { name: 'Porter' },
    { name: 'Potsdam' },
    { name: 'Poughkeepsie' },
    { name: 'Putnam Valley' },
    { name: 'Queensbury' },
    { name: 'Ramapo' },
    { name: 'Red Hook' },
    { name: 'Rensselaer' },
    { name: 'Rhinebeck' },
    { name: 'Ridge' },
    { name: 'Ridgeway' },
    { name: 'Riverhead' },
    { name: 'Rochester' },
    { name: 'Rockville Centre' },
    { name: 'Rocky Point' },
    { name: 'Rome' },
    { name: 'Ronkonkoma' },
    { name: 'Roosevelt' },
    { name: 'Rosendale' },
    { name: 'Roslyn Heights' },
    { name: 'Rotterdam' },
    { name: 'Royalton' },
    { name: 'Rye' },
    { name: 'Rye Brook' },
    { name: 'Salamanca' },
    { name: 'Salina' },
    { name: 'Salisbury' },
    { name: 'Sand Lake' },
    { name: 'Saratoga Springs' },
    { name: 'Saugerties' },
    { name: 'Sayville' },
    { name: 'Scarsdale' },
    { name: 'Schaghticoke' },
    { name: 'Schenectady' },
    { name: 'Schodack' },
    { name: 'Schroeppel' },
    { name: 'Scotchtown' },
    { name: 'Scotia' },
    { name: 'Scriba' },
    { name: 'Seaford' },
    { name: 'Selden' },
    { name: 'Seneca Falls' },
    { name: 'Setauket-East Setauket' },
    { name: 'Shawangunk' },
    { name: 'Shirley' },
    { name: 'Sidney' },
    { name: 'Skaneateles' },
    { name: 'Sleepy Hollow' },
    { name: 'Smithtown' },
    { name: 'Sodus' },
    { name: 'Solvay' },
    { name: 'Somers' },
    { name: 'Sound Beach' },
    { name: 'South Farmingdale' },
    { name: 'South Hill' },
    { name: 'South Huntington' },
    { name: 'South Lockport' },
    { name: 'Southampton' },
    { name: 'Southeast' },
    { name: 'Southold' },
    { name: 'Southport' },
    { name: 'Spring Valley' },
    { name: 'St. James' },
    { name: 'Stillwater' },
    { name: 'Stony Brook' },
    { name: 'Stony Point' },
    { name: 'Suffern' },
    { name: 'Sullivan' },
    { name: 'Sweden' },
    { name: 'Syosset' },
    { name: 'Syracuse' },
    { name: 'Tappan' },
    { name: 'Tarrytown' },
    { name: 'Terryville' },
    { name: 'Thompson' },
    { name: 'Tonawanda' },
    { name: 'Troy' },
    { name: 'Tuckahoe' },
    { name: 'Ulster' },
    { name: 'Union' },
    { name: 'Uniondale' },
    { name: 'Utica' },
    { name: 'Valley Cottage' },
    { name: 'Valley Stream' },
    { name: 'Van Buren' },
    { name: 'Verona' },
    { name: 'Vestal' },
    { name: 'Victor' },
    { name: 'Volney' },
    { name: 'Wading River' },
    { name: 'Walden' },
    { name: 'Wallkill' },
    { name: 'Walworth' },
    { name: 'Wantagh' },
    { name: 'Wappinger' },
    { name: 'Warwick' },
    { name: 'Waterford' },
    { name: 'Waterloo' },
    { name: 'Watertown' },
    { name: 'Watervliet' },
    { name: 'Wawarsing' },
    { name: 'Wawayanda' },
    { name: 'Webster' },
    { name: 'Wellsville' },
    { name: 'West Babylon' },
    { name: 'West Glens Falls' },
    { name: 'West Haverstraw' },
    { name: 'West Hempstead' },
    { name: 'West Islip' },
    { name: 'West Point' },
    { name: 'West Seneca' },
    { name: 'Westbury' },
    { name: 'Westmere' },
    { name: 'Westmoreland' },
    { name: 'Wheatfield' },
    { name: 'White Plains' },
    { name: 'Whitestown' },
    { name: 'Williamson' },
    { name: 'Williston Park' },
    { name: 'Wilna' },
    { name: 'Wilton' },
    { name: 'Windsor' },
    { name: 'Woodbury' },
    { name: 'Woodmere' },
    { name: 'Woodstock' },
    { name: 'Wyandanch' },
    { name: 'Yonkers' },
    { name: 'Yorktown' },
    { name: 'Yorktown Heights' },
  ],
  'north-carolina': [
    { name: 'Albemarle' },
    { name: 'Apex' },
    { name: 'Archdale' },
    { name: 'Asheboro' },
    { name: 'Asheville' },
    { name: 'Belmont' },
    { name: 'Black Mountain' },
    { name: 'Boone' },
    { name: 'Brevard' },
    { name: 'Burlington' },
    { name: 'Carrboro' },
    { name: 'Cary' },
    { name: 'Chapel Hill' },
    { name: 'Charlotte' },
    { name: 'Clayton' },
    { name: 'Clemmons' },
    { name: 'Clinton' },
    { name: 'Concord' },
    { name: 'Conover' },
    { name: 'Cornelius' },
    { name: 'Davidson' },
    { name: 'Dunn' },
    { name: 'Durham' },
    { name: 'Eden' },
    { name: 'Elizabeth City' },
    { name: 'Elon College' },
    { name: 'Fayetteville' },
    { name: 'Forest City' },
    { name: 'Fort Bragg' },
    { name: 'Fuquay-Varina' },
    { name: 'Garner' },
    { name: 'Gastonia' },
    { name: 'Goldsboro' },
    { name: 'Graham' },
    { name: 'Greensboro' },
    { name: 'Greenville' },
    { name: 'Half Moon' },
    { name: 'Hamlet' },
    { name: 'Havelock' },
    { name: 'Henderson' },
    { name: 'Hendersonville' },
    { name: 'Hickory' },
    { name: 'High Point' },
    { name: 'Holly Springs' },
    { name: 'Hope Mills' },
    { name: 'Huntersville' },
    { name: 'Indian Trail' },
    { name: 'Jacksonville' },
    { name: 'Kannapolis' },
    { name: 'Kernersville' },
    { name: 'Kings Grant' },
    { name: 'Kings Mountain' },
    { name: 'Kinston' },
    { name: 'Laurinburg' },
    { name: 'Lenoir' },
    { name: 'Lewisville' },
    { name: 'Lexington' },
    { name: 'Lincolnton' },
    { name: 'Lumberton' },
    { name: 'Masonboro' },
    { name: 'Matthews' },
    { name: 'Mebane' },
    { name: 'Mint Hill' },
    { name: 'Monroe' },
    { name: 'Mooresville' },
    { name: 'Morehead City' },
    { name: 'Morganton' },
    { name: 'Mount Airy' },
    { name: 'Mount Holly' },
    { name: 'Murraysville' },
    { name: 'Myrtle Grove' },
    { name: 'New Bern' },
    { name: 'Newton' },
    { name: 'Oak Island' },
    { name: 'Oxford' },
    { name: 'Pinehurst' },
    { name: 'Piney Green' },
    { name: 'Raleigh' },
    { name: 'Reidsville' },
    { name: 'Roanoke Rapids' },
    { name: 'Rockingham' },
    { name: 'Rocky Mount' },
    { name: 'Roxboro' },
    { name: 'Salisbury' },
    { name: 'Sanford' },
    { name: 'Shelby' },
    { name: 'Siler City' },
    { name: 'Smithfield' },
    { name: 'Southern Pines' },
    { name: 'Spring Lake' },
    { name: 'St. Stephens' },
    { name: 'Statesville' },
    { name: 'Summerfield' },
    { name: 'Tarboro' },
    { name: 'Thomasville' },
    { name: 'Trinity' },
    { name: 'Wake Forest' },
    { name: 'Washington' },
    { name: 'Waynesville' },
    { name: 'Weddington' },
    { name: 'Wilmington' },
    { name: 'Wilson' },
    { name: 'Winston-Salem' },
  ],
  'north-dakota': [
    { name: 'Bismarck' },
    { name: 'Devils Lake' },
    { name: 'Dickinson' },
    { name: 'Fargo' },
    { name: 'Grand Forks' },
    { name: 'Jamestown' },
    { name: 'Mandan' },
    { name: 'Minot' },
    { name: 'Minot AFB' },
    { name: 'Valley City' },
    { name: 'Wahpeton' },
    { name: 'West Fargo' },
    { name: 'Williston' },
  ],
  'ohio': [
    { name: 'Akron' },
    { name: 'Alliance' },
    { name: 'Amherst' },
    { name: 'Ashland' },
    { name: 'Ashtabula' },
    { name: 'Athens' },
    { name: 'Aurora' },
    { name: 'Austintown' },
    { name: 'Avon' },
    { name: 'Avon Lake' },
    { name: 'Barberton' },
    { name: 'Bay Village' },
    { name: 'Beachwood' },
    { name: 'Beavercreek' },
    { name: 'Beckett Ridge' },
    { name: 'Bedford' },
    { name: 'Bedford Heights' },
    { name: 'Bellbrook' },
    { name: 'Bellefontaine' },
    { name: 'Bellevue' },
    { name: 'Belpre' },
    { name: 'Berea' },
    { name: 'Bexley' },
    { name: 'Blacklick Estates' },
    { name: 'Blue Ash' },
    { name: 'Boardman' },
    { name: 'Bowling Green' },
    { name: 'Brecksville' },
    { name: 'Bridgetown North' },
    { name: 'Broadview Heights' },
    { name: 'Brook Park' },
    { name: 'Brooklyn' },
    { name: 'Brunswick' },
    { name: 'Bryan' },
    { name: 'Bucyrus' },
    { name: 'Cambridge' },
    { name: 'Campbell' },
    { name: 'Canfield' },
    { name: 'Canton' },
    { name: 'Celina' },
    { name: 'Centerville' },
    { name: 'Cheviot' },
    { name: 'Chillicothe' },
    { name: 'Cincinnati' },
    { name: 'Circleville' },
    { name: 'Clayton' },
    { name: 'Cleveland' },
    { name: 'Cleveland Heights' },
    { name: 'Clyde' },
    { name: 'Columbus' },
    { name: 'Conneaut' },
    { name: 'Cortland' },
    { name: 'Coshocton' },
    { name: 'Covedale' },
    { name: 'Cuyahoga Falls' },
    { name: 'Dayton' },
    { name: 'Defiance' },
    { name: 'Delaware' },
    { name: 'Delphos' },
    { name: 'Dent' },
    { name: 'Dover' },
    { name: 'Dry Run' },
    { name: 'Dublin' },
    { name: 'East Cleveland' },
    { name: 'East Liverpool' },
    { name: 'Eastlake' },
    { name: 'Eaton' },
    { name: 'Elyria' },
    { name: 'Englewood' },
    { name: 'Euclid' },
    { name: 'Fairborn' },
    { name: 'Fairfield' },
    { name: 'Fairlawn' },
    { name: 'Fairview Park' },
    { name: 'Findlay' },
    { name: 'Finneytown' },
    { name: 'Forest Park' },
    { name: 'Forestville' },
    { name: 'Fostoria' },
    { name: 'Franklin' },
    { name: 'Fremont' },
    { name: 'Gahanna' },
    { name: 'Galion' },
    { name: 'Garfield Heights' },
    { name: 'Geneva' },
    { name: 'Girard' },
    { name: 'Grandview Heights' },
    { name: 'Green' },
    { name: 'Greenville' },
    { name: 'Groesbeck' },
    { name: 'Grove City' },
    { name: 'Hamilton' },
    { name: 'Harrison' },
    { name: 'Heath' },
    { name: 'Highland Heights' },
    { name: 'Hilliard' },
    { name: 'Hillsboro' },
    { name: 'Howland Center' },
    { name: 'Hubbard' },
    { name: 'Huber Heights' },
    { name: 'Hudson' },
    { name: 'Huron' },
    { name: 'Independence' },
    { name: 'Ironton' },
    { name: 'Jackson' },
    { name: 'Kent' },
    { name: 'Kenton' },
    { name: 'Kenwood' },
    { name: 'Kettering' },
    { name: 'Kirtland' },
    { name: 'Lakewood' },
    { name: 'Lancaster' },
    { name: 'Landen' },
    { name: 'Lebanon' },
    { name: 'Lima' },
    { name: 'Lincoln Village' },
    { name: 'Logan' },
    { name: 'London' },
    { name: 'Lorain' },
    { name: 'Louisville' },
    { name: 'Loveland' },
    { name: 'Lyndhurst' },
    { name: 'Macedonia' },
    { name: 'Madeira' },
    { name: 'Mansfield' },
    { name: 'Maple Heights' },
    { name: 'Marietta' },
    { name: 'Marion' },
    { name: 'Martins Ferry' },
    { name: 'Marysville' },
    { name: 'Mason' },
    { name: 'Massillon' },
    { name: 'Maumee' },
    { name: 'Mayfield Heights' },
    { name: 'Medina' },
    { name: 'Mentor' },
    { name: 'Mentor-on-the-Lake' },
    { name: 'Miamisburg' },
    { name: 'Middleburg Heights' },
    { name: 'Middletown' },
    { name: 'Milford' },
    { name: 'Monroe' },
    { name: 'Montgomery' },
    { name: 'Moraine' },
    { name: 'Mount Healthy' },
    { name: 'Mount Vernon' },
    { name: 'Napoleon' },
    { name: 'New Philadelphia' },
    { name: 'Newark' },
    { name: 'Niles' },
    { name: 'North Canton' },
    { name: 'North College Hill' },
    { name: 'North Madison' },
    { name: 'North Olmsted' },
    { name: 'North Ridgeville' },
    { name: 'North Royalton' },
    { name: 'Northbrook' },
    { name: 'Northgate' },
    { name: 'Northridge' },
    { name: 'Norton' },
    { name: 'Norwalk' },
    { name: 'Norwood' },
    { name: 'Oakwood' },
    { name: 'Oberlin' },
    { name: 'Olmsted Falls' },
    { name: 'Oregon' },
    { name: 'Orrville' },
    { name: 'Oxford' },
    { name: 'Painesville' },
    { name: 'Parma' },
    { name: 'Parma Heights' },
    { name: 'Pataskala' },
    { name: 'Pepper Pike' },
    { name: 'Perry Heights' },
    { name: 'Perrysburg' },
    { name: 'Pickerington' },
    { name: 'Piqua' },
    { name: 'Port Clinton' },
    { name: 'Portage Lakes' },
    { name: 'Portsmouth' },
    { name: 'Powell' },
    { name: 'Ravenna' },
    { name: 'Reading' },
    { name: 'Reynoldsburg' },
    { name: 'Richmond Heights' },
    { name: 'Rittman' },
    { name: 'Riverside' },
    { name: 'Rocky River' },
    { name: 'Rossford' },
    { name: 'Salem' },
    { name: 'Sandusky' },
    { name: 'Sandusky South' },
    { name: 'Seven Hills' },
    { name: 'Shaker Heights' },
    { name: 'Sharonville' },
    { name: 'Sheffield Lake' },
    { name: 'Shelby' },
    { name: 'Shiloh' },
    { name: 'Sidney' },
    { name: 'Solon' },
    { name: 'South Euclid' },
    { name: 'Springboro' },
    { name: 'Springdale' },
    { name: 'Springfield' },
    { name: 'St. Marys' },
    { name: 'Steubenville' },
    { name: 'Stow' },
    { name: 'Streetsboro' },
    { name: 'Strongsville' },
    { name: 'Struthers' },
    { name: 'Sylvania' },
    { name: 'Tallmadge' },
    { name: 'Tiffin' },
    { name: 'Tipp City' },
    { name: 'Toledo' },
    { name: 'Trenton' },
    { name: 'Trotwood' },
    { name: 'Troy' },
    { name: 'Twinsburg' },
    { name: 'University Heights' },
    { name: 'Upper Arlington' },
    { name: 'Upper Sandusky' },
    { name: 'Urbana' },
    { name: 'Van Wert' },
    { name: 'Vandalia' },
    { name: 'Vermilion' },
    { name: 'Wadsworth' },
    { name: 'Wapakoneta' },
    { name: 'Warren' },
    { name: 'Warrensville Heights' },
    { name: 'Washington' },
    { name: 'Wauseon' },
    { name: 'Wellston' },
    { name: 'West Carrollton City' },
    { name: 'Westerville' },
    { name: 'Westlake' },
    { name: 'Wheelersburg' },
    { name: 'White Oak' },
    { name: 'Whitehall' },
    { name: 'Wickliffe' },
    { name: 'Willard' },
    { name: 'Willoughby' },
    { name: 'Willoughby Hills' },
    { name: 'Willowick' },
    { name: 'Wilmington' },
    { name: 'Woodbourne-Hyde Park' },
    { name: 'Wooster' },
    { name: 'Worthington' },
    { name: 'Wright-Patterson AFB' },
    { name: 'Wyoming' },
    { name: 'Xenia' },
    { name: 'Youngstown' },
    { name: 'Zanesville' },
  ],
  'oklahoma': [
    { name: 'Ada' },
    { name: 'Altus' },
    { name: 'Anadarko' },
    { name: 'Ardmore' },
    { name: 'Bartlesville' },
    { name: 'Bethany' },
    { name: 'Bixby' },
    { name: 'Blackwell' },
    { name: 'Broken Arrow' },
    { name: 'Chickasha' },
    { name: 'Choctaw' },
    { name: 'Claremore' },
    { name: 'Clinton' },
    { name: 'Coweta' },
    { name: 'Cushing' },
    { name: 'Del City' },
    { name: 'Duncan' },
    { name: 'Durant' },
    { name: 'Edmond' },
    { name: 'El Reno' },
    { name: 'Elk City' },
    { name: 'Enid' },
    { name: 'Glenpool' },
    { name: 'Guthrie' },
    { name: 'Guymon' },
    { name: 'Henryetta' },
    { name: 'Idabel' },
    { name: 'Jenks' },
    { name: 'Lawton' },
    { name: 'McAlester' },
    { name: 'Miami' },
    { name: 'Midwest City' },
    { name: 'Moore' },
    { name: 'Muskogee' },
    { name: 'Mustang' },
    { name: 'Norman' },
    { name: 'Oklahoma City' },
    { name: 'Okmulgee' },
    { name: 'Owasso' },
    { name: 'Pauls Valley' },
    { name: 'Ponca City' },
    { name: 'Poteau' },
    { name: 'Pryor Creek' },
    { name: 'Sallisaw' },
    { name: 'Sand Springs' },
    { name: 'Sapulpa' },
    { name: 'Seminole' },
    { name: 'Shawnee' },
    { name: 'Stillwater' },
    { name: 'Tahlequah' },
    { name: 'Tecumseh' },
    { name: 'The Village' },
    { name: 'Tulsa' },
    { name: 'Vinita' },
    { name: 'Wagoner' },
    { name: 'Warr Acres' },
    { name: 'Weatherford' },
    { name: 'Woodward' },
    { name: 'Yukon' },
  ],
  'oregon': [
    { name: 'Albany' },
    { name: 'Aloha' },
    { name: 'Altamont' },
    { name: 'Ashland' },
    { name: 'Astoria' },
    { name: 'Baker City' },
    { name: 'Beaverton' },
    { name: 'Bend' },
    { name: 'Canby' },
    { name: 'Cedar Hills' },
    { name: 'Cedar Mill' },
    { name: 'Central Point' },
    { name: 'City of The Dalles' },
    { name: 'Coos Bay' },
    { name: 'Cornelius' },
    { name: 'Corvallis' },
    { name: 'Cottage Grove' },
    { name: 'Dallas' },
    { name: 'Eugene' },
    { name: 'Fairview' },
    { name: 'Florence' },
    { name: 'Forest Grove' },
    { name: 'Four Corners' },
    { name: 'Garden Home-Whitford' },
    { name: 'Gladstone' },
    { name: 'Grants Pass' },
    { name: 'Green' },
    { name: 'Gresham' },
    { name: 'Hayesville' },
    { name: 'Hermiston' },
    { name: 'Hillsboro' },
    { name: 'Independence' },
    { name: 'Jennings Lodge' },
    { name: 'Keizer' },
    { name: 'Klamath Falls' },
    { name: 'La Grande' },
    { name: 'Lake Oswego' },
    { name: 'Lebanon' },
    { name: 'Lincoln City' },
    { name: 'McMinnville' },
    { name: 'Medford' },
    { name: 'Milton-Freewater' },
    { name: 'Milwaukie' },
    { name: 'Monmouth' },
    { name: 'Newberg' },
    { name: 'Newport' },
    { name: 'North Bend' },
    { name: 'Oak Grove' },
    { name: 'Oak Hills' },
    { name: 'Oatfield' },
    { name: 'Ontario' },
    { name: 'Oregon City' },
    { name: 'Pendleton' },
    { name: 'Portland' },
    { name: 'Prineville' },
    { name: 'Redmond' },
    { name: 'Rockcreek' },
    { name: 'Roseburg' },
    { name: 'Salem' },
    { name: 'Sherwood' },
    { name: 'Silverton' },
    { name: 'Springfield' },
    { name: 'St. Helens' },
    { name: 'Stayton' },
    { name: 'Sunnyside' },
    { name: 'Sutherlin' },
    { name: 'Sweet Home' },
    { name: 'Tigard' },
    { name: 'Troutdale' },
    { name: 'Tualatin' },
    { name: 'West Haven-Sylvan' },
    { name: 'West Linn' },
    { name: 'West Slope' },
    { name: 'Wilsonville' },
    { name: 'Woodburn' },
  ],
  'pennsylvania': [
    { name: 'Aliquippa' },
    { name: 'Allentown' },
    { name: 'Altoona' },
    { name: 'Ambler' },
    { name: 'Ambridge' },
    { name: 'Archbald' },
    { name: 'Ardmore' },
    { name: 'Audubon' },
    { name: 'Back Mountain' },
    { name: 'Baldwin' },
    { name: 'Beaver Falls' },
    { name: 'Bellefonte' },
    { name: 'Bellevue' },
    { name: 'Berwick' },
    { name: 'Bethel Park' },
    { name: 'Bethlehem' },
    { name: 'Blakely' },
    { name: 'Bloomsburg' },
    { name: 'Blue Bell' },
    { name: 'Bradford' },
    { name: 'Brentwood' },
    { name: 'Bristol' },
    { name: 'Brookhaven' },
    { name: 'Broomall' },
    { name: 'Butler' },
    { name: 'Camp Hill' },
    { name: 'Canonsburg' },
    { name: 'Carbondale' },
    { name: 'Carlisle' },
    { name: 'Carnegie' },
    { name: 'Carnot-Moon' },
    { name: 'Castle Shannon' },
    { name: 'Catasauqua' },
    { name: 'Chambersburg' },
    { name: 'Chester' },
    { name: 'Clairton' },
    { name: 'Clarion' },
    { name: 'Clearfield' },
    { name: 'Clifton Heights' },
    { name: 'Coatesville' },
    { name: 'Collegeville' },
    { name: 'Collingdale' },
    { name: 'Colonial Park' },
    { name: 'Columbia' },
    { name: 'Connellsville' },
    { name: 'Conshohocken' },
    { name: 'Coraopolis' },
    { name: 'Corry' },
    { name: 'Crafton' },
    { name: 'Croydon' },
    { name: 'Darby' },
    { name: 'Darby Township' },
    { name: 'Dickson City' },
    { name: 'Dormont' },
    { name: 'Downingtown' },
    { name: 'Doylestown' },
    { name: 'Drexel Hill' },
    { name: 'DuBois' },
    { name: 'Dunmore' },
    { name: 'Duquesne' },
    { name: 'East Norriton' },
    { name: 'East Stroudsburg' },
    { name: 'East York' },
    { name: 'Easton' },
    { name: 'Economy' },
    { name: 'Edinboro' },
    { name: 'Elizabethtown' },
    { name: 'Ellwood City' },
    { name: 'Emmaus' },
    { name: 'Ephrata' },
    { name: 'Erie' },
    { name: 'Fairless Hills' },
    { name: 'Farrell' },
    { name: 'Feasterville-Trevose' },
    { name: 'Fernway' },
    { name: 'Folcroft' },
    { name: 'Folsom' },
    { name: 'Forest Hills' },
    { name: 'Franklin' },
    { name: 'Franklin Park' },
    { name: 'Fullerton' },
    { name: 'Gettysburg' },
    { name: 'Glenolden' },
    { name: 'Glenside' },
    { name: 'Greensburg' },
    { name: 'Greenville' },
    { name: 'Grove City' },
    { name: 'Hampton Township' },
    { name: 'Hanover' },
    { name: 'Harleysville' },
    { name: 'Harrisburg' },
    { name: 'Harrison Township' },
    { name: 'Hatboro' },
    { name: 'Hazleton' },
    { name: 'Hermitage' },
    { name: 'Hershey' },
    { name: 'Homeacre-Lyndora' },
    { name: 'Horsham' },
    { name: 'Huntingdon' },
    { name: 'Indiana' },
    { name: 'Jeannette' },
    { name: 'Jefferson Hills' },
    { name: 'Johnstown' },
    { name: 'Kennedy Township' },
    { name: 'King of Prussia' },
    { name: 'Kingston' },
    { name: 'Kulpsville' },
    { name: 'Lancaster' },
    { name: 'Lansdale' },
    { name: 'Lansdowne' },
    { name: 'Latrobe' },
    { name: 'Leacock-Leola-Bareville' },
    { name: 'Lebanon' },
    { name: 'Levittown' },
    { name: 'Lewistown' },
    { name: 'Linglestown' },
    { name: 'Lionville-Marchwood' },
    { name: 'Lititz' },
    { name: 'Lock Haven' },
    { name: 'Lower Allen' },
    { name: 'Lower Burrell' },
    { name: 'Maple Glen' },
    { name: 'McCandless Township' },
    { name: 'McKees Rocks' },
    { name: 'McKeesport' },
    { name: 'Meadville' },
    { name: 'Mechanicsburg' },
    { name: 'Middletown' },
    { name: 'Millersville' },
    { name: 'Milton' },
    { name: 'Monaca' },
    { name: 'Monessen' },
    { name: 'Montgomeryville' },
    { name: 'Morrisville' },
    { name: 'Mount Carmel' },
    { name: 'Mount Joy' },
    { name: 'Mount Lebanon' },
    { name: 'Mountain Top' },
    { name: 'Munhall' },
    { name: 'Municipality of Monroeville' },
    { name: 'Municipality of Murrysville' },
    { name: 'Nanticoke' },
    { name: 'Nazareth' },
    { name: 'Nether Providence Township' },
    { name: 'New Brighton' },
    { name: 'New Castle' },
    { name: 'New Cumberland' },
    { name: 'New Kensington' },
    { name: 'Norristown' },
    { name: 'North Braddock' },
    { name: 'North Versailles' },
    { name: 'Northampton' },
    { name: 'Northwest Harborcreek' },
    { name: 'O’Hara Township' },
    { name: 'Oakmont' },
    { name: 'Oil City' },
    { name: 'Old Forge' },
    { name: 'Palmyra' },
    { name: 'Park Forest Village' },
    { name: 'Parkville' },
    { name: 'Penn Hills' },
    { name: 'Perkasie' },
    { name: 'Philadelphia' },
    { name: 'Phoenixville' },
    { name: 'Pittsburgh' },
    { name: 'Pittston' },
    { name: 'Pleasant Hills' },
    { name: 'Plum' },
    { name: 'Plymouth' },
    { name: 'Pottstown' },
    { name: 'Pottsville' },
    { name: 'Progress' },
    { name: 'Prospect Park' },
    { name: 'Punxsutawney' },
    { name: 'Quakertown' },
    { name: 'Radnor Township' },
    { name: 'Reading' },
    { name: 'Red Lion' },
    { name: 'Richboro' },
    { name: 'Ridley Park' },
    { name: 'Robinson Township' },
    { name: 'Ross Township' },
    { name: 'Sanatoga' },
    { name: 'Scott Township' },
    { name: 'Scranton' },
    { name: 'Shaler Township' },
    { name: 'Shamokin' },
    { name: 'Sharon' },
    { name: 'Shiloh' },
    { name: 'Somerset' },
    { name: 'Souderton' },
    { name: 'South Park Township' },
    { name: 'South Williamsport' },
    { name: 'Springfield' },
    { name: 'St. Marys' },
    { name: 'State College' },
    { name: 'Stowe Township' },
    { name: 'Sunbury' },
    { name: 'Swarthmore' },
    { name: 'Swissvale' },
    { name: 'Tamaqua' },
    { name: 'Taylor' },
    { name: 'Titusville' },
    { name: 'Trooper' },
    { name: 'Turtle Creek' },
    { name: 'Uniontown' },
    { name: 'Upper Providence Township' },
    { name: 'Upper St. Clair' },
    { name: 'Village Green-Green Ridge' },
    { name: 'Warren' },
    { name: 'Washington' },
    { name: 'Waynesboro' },
    { name: 'Weigelstown' },
    { name: 'West Chester' },
    { name: 'West Goshen' },
    { name: 'West Mifflin' },
    { name: 'West Norriton' },
    { name: 'West View' },
    { name: 'White Oak' },
    { name: 'Whitehall' },
    { name: 'Wilkes-Barre' },
    { name: 'Wilkins Township' },
    { name: 'Wilkinsburg' },
    { name: 'Williamsport' },
    { name: 'Willow Grove' },
    { name: 'Willow Street' },
    { name: 'Wilson' },
    { name: 'Woodlyn' },
    { name: 'Wyomissing' },
    { name: 'Yeadon' },
    { name: 'York' },
  ],
  'rhode-island': [
    { name: 'Barrington' },
    { name: 'Bristol' },
    { name: 'Burrillville' },
    { name: 'Central Falls' },
    { name: 'Charlestown' },
    { name: 'Coventry' },
    { name: 'Cranston' },
    { name: 'Cumberland' },
    { name: 'Cumberland Hill' },
    { name: 'East Greenwich' },
    { name: 'East Providence' },
    { name: 'Exeter' },
    { name: 'Glocester' },
    { name: 'Greenville' },
    { name: 'Hopkinton' },
    { name: 'Johnston' },
    { name: 'Lincoln' },
    { name: 'Middletown' },
    { name: 'Narragansett' },
    { name: 'Newport' },
    { name: 'Newport East' },
    { name: 'North Kingstown' },
    { name: 'North Providence' },
    { name: 'North Smithfield' },
    { name: 'Pawtucket' },
    { name: 'Portsmouth' },
    { name: 'Providence' },
    { name: 'Richmond' },
    { name: 'Scituate' },
    { name: 'Smithfield' },
    { name: 'South Kingstown' },
    { name: 'Tiverton' },
    { name: 'Valley Falls' },
    { name: 'Wakefield-Peacedale' },
    { name: 'Warren' },
    { name: 'Warwick' },
    { name: 'West Warwick' },
    { name: 'Westerly' },
    { name: 'Woonsocket' },
  ],
  'south-carolina': [
    { name: 'Aiken' },
    { name: 'Anderson' },
    { name: 'Beaufort' },
    { name: 'Bennettsville' },
    { name: 'Berea' },
    { name: 'Burton' },
    { name: 'Camden' },
    { name: 'Cayce' },
    { name: 'Charleston' },
    { name: 'Chester' },
    { name: 'Clemson' },
    { name: 'Clinton' },
    { name: 'Columbia' },
    { name: 'Conway' },
    { name: 'Darlington' },
    { name: 'Dentsville' },
    { name: 'Dillon' },
    { name: 'Easley' },
    { name: 'Five Forks' },
    { name: 'Florence' },
    { name: 'Forest Acres' },
    { name: 'Fort Mill' },
    { name: 'Fountain Inn' },
    { name: 'Gaffney' },
    { name: 'Gantt' },
    { name: 'Garden City' },
    { name: 'Georgetown' },
    { name: 'Georgetown County' },
    { name: 'Goose Creek' },
    { name: 'Greenville' },
    { name: 'Greenwood' },
    { name: 'Greer' },
    { name: 'Hanahan' },
    { name: 'Hartsville' },
    { name: 'Hilton Head Island' },
    { name: 'Homeland Park' },
    { name: 'Irmo' },
    { name: 'Ladson' },
    { name: 'Lake City' },
    { name: 'Lancaster' },
    { name: 'Laurel Bay' },
    { name: 'Laurens' },
    { name: 'Lexington' },
    { name: 'Little River' },
    { name: 'Lugoff' },
    { name: 'Marion' },
    { name: 'Mauldin' },
    { name: 'Mount Pleasant' },
    { name: 'Myrtle Beach' },
    { name: 'Newberry' },
    { name: 'North Augusta' },
    { name: 'North Charleston' },
    { name: 'North Myrtle Beach' },
    { name: 'Oak Grove' },
    { name: 'Orangeburg' },
    { name: 'Parker' },
    { name: 'Red Bank' },
    { name: 'Red Hill' },
    { name: 'Rock Hill' },
    { name: 'Sans Souci' },
    { name: 'Seneca' },
    { name: 'Seven Oaks' },
    { name: 'Simpsonville' },
    { name: 'Socastee' },
    { name: 'Spartanburg' },
    { name: 'St. Andrews' },
    { name: 'Summerville' },
    { name: 'Sumter' },
    { name: 'Taylors' },
    { name: 'Union' },
    { name: 'Wade Hampton' },
    { name: 'Welcome' },
    { name: 'West Columbia' },
    { name: 'Woodfield' },
    { name: 'York' },
  ],
  'south-dakota': [
    { name: 'Aberdeen' },
    { name: 'Brookings' },
    { name: 'Huron' },
    { name: 'Madison' },
    { name: 'Mitchell' },
    { name: 'Pierre' },
    { name: 'Rapid City' },
    { name: 'Rapid Valley' },
    { name: 'Sioux Falls' },
    { name: 'Spearfish' },
    { name: 'Sturgis' },
    { name: 'Vermillion' },
    { name: 'Watertown' },
    { name: 'Yankton' },
  ],
  'tennessee': [
    { name: 'Alcoa' },
    { name: 'Athens' },
    { name: 'Bartlett' },
    { name: 'Bloomingdale' },
    { name: 'Brentwood' },
    { name: 'Bristol' },
    { name: 'Brownsville' },
    { name: 'Chattanooga' },
    { name: 'Clarksville' },
    { name: 'Cleveland' },
    { name: 'Clinton' },
    { name: 'Collegedale' },
    { name: 'Collierville' },
    { name: 'Colonial Heights' },
    { name: 'Columbia' },
    { name: 'Cookeville' },
    { name: 'Covington' },
    { name: 'Crossville' },
    { name: 'Dayton' },
    { name: 'Dickson' },
    { name: 'Dyersburg' },
    { name: 'East Brainerd' },
    { name: 'East Ridge' },
    { name: 'Elizabethton' },
    { name: 'Farragut' },
    { name: 'Fayetteville' },
    { name: 'Franklin' },
    { name: 'Gallatin' },
    { name: 'Germantown' },
    { name: 'Goodlettsville' },
    { name: 'Green Hill' },
    { name: 'Greeneville' },
    { name: 'Harriman' },
    { name: 'Harrison' },
    { name: 'Hendersonville' },
    { name: 'Humboldt' },
    { name: 'Jackson' },
    { name: 'Jefferson City' },
    { name: 'Johnson City' },
    { name: 'Kingsport' },
    { name: 'Knoxville' },
    { name: 'La Follette' },
    { name: 'La Vergne' },
    { name: 'Lakeland' },
    { name: 'Lawrenceburg' },
    { name: 'Lebanon' },
    { name: 'Lenoir City' },
    { name: 'Lewisburg' },
    { name: 'Lexington' },
    { name: 'Manchester' },
    { name: 'Martin' },
    { name: 'Maryville' },
    { name: 'McMinnville' },
    { name: 'Memphis' },
    { name: 'Middle Valley' },
    { name: 'Milan' },
    { name: 'Millington' },
    { name: 'Morristown' },
    { name: 'Mount Juliet' },
    { name: 'Murfreesboro' },
    { name: 'Nashville-Davidson' },
    { name: 'Newport' },
    { name: 'Oak Ridge' },
    { name: 'Paris' },
    { name: 'Portland' },
    { name: 'Pulaski' },
    { name: 'Red Bank' },
    { name: 'Ripley' },
    { name: 'Savannah' },
    { name: 'Sevierville' },
    { name: 'Seymour' },
    { name: 'Shelbyville' },
    { name: 'Signal Mountain' },
    { name: 'Smyrna' },
    { name: 'Soddy-Daisy' },
    { name: 'South Cleveland' },
    { name: 'Spring Hill' },
    { name: 'Springfield' },
    { name: 'Tullahoma' },
    { name: 'Union City' },
    { name: 'White House' },
    { name: 'Winchester' },
  ],
  'texas': [
    { name: 'Abilene' },
    { name: 'Addison' },
    { name: 'Alamo' },
    { name: 'Alamo Heights' },
    { name: 'Aldine' },
    { name: 'Alice' },
    { name: 'Allen' },
    { name: 'Alvin' },
    { name: 'Amarillo' },
    { name: 'Anderson Mill' },
    { name: 'Andrews' },
    { name: 'Angleton' },
    { name: 'Aransas Pass' },
    { name: 'Arlington' },
    { name: 'Atascocita' },
    { name: 'Athens' },
    { name: 'Austin' },
    { name: 'Azle' },
    { name: 'Bacliff' },
    { name: 'Balch Springs' },
    { name: 'Bay City' },
    { name: 'Baytown' },
    { name: 'Beaumont' },
    { name: 'Bedford' },
    { name: 'Beeville' },
    { name: 'Bellaire' },
    { name: 'Bellmead' },
    { name: 'Belton' },
    { name: 'Benbrook' },
    { name: 'Big Spring' },
    { name: 'Boerne' },
    { name: 'Bonham' },
    { name: 'Borger' },
    { name: 'Brenham' },
    { name: 'Bridge City' },
    { name: 'Brownfield' },
    { name: 'Brownsville' },
    { name: 'Brownwood' },
    { name: 'Brushy Creek' },
    { name: 'Bryan' },
    { name: 'Burkburnett' },
    { name: 'Burleson' },
    { name: 'Canyon' },
    { name: 'Canyon Lake' },
    { name: 'Carrollton' },
    { name: 'Carthage' },
    { name: 'Cedar Hill' },
    { name: 'Cedar Park' },
    { name: 'Channelview' },
    { name: 'Childress' },
    { name: 'Cinco Ranch' },
    { name: 'Cleburne' },
    { name: 'Cleveland' },
    { name: 'Cloverleaf' },
    { name: 'Clute' },
    { name: 'College Station' },
    { name: 'Colleyville' },
    { name: 'Commerce' },
    { name: 'Conroe' },
    { name: 'Converse' },
    { name: 'Coppell' },
    { name: 'Copperas Cove' },
    { name: 'Corinth' },
    { name: 'Corpus Christi' },
    { name: 'Corsicana' },
    { name: 'Crockett' },
    { name: 'Crowley' },
    { name: 'Crystal City' },
    { name: 'Cuero' },
    { name: 'Dalhart' },
    { name: 'Dallas' },
    { name: 'Deer Park' },
    { name: 'Del Rio' },
    { name: 'Denison' },
    { name: 'Denton' },
    { name: 'DeSoto' },
    { name: 'Dickinson' },
    { name: 'Donna' },
    { name: 'Dumas' },
    { name: 'Duncanville' },
    { name: 'Eagle Mountain' },
    { name: 'Eagle Pass' },
    { name: 'Edinburg' },
    { name: 'Eidson Road' },
    { name: 'El Campo' },
    { name: 'El Paso' },
    { name: 'Ennis' },
    { name: 'Euless' },
    { name: 'Fabens' },
    { name: 'Farmers Branch' },
    { name: 'Flower Mound' },
    { name: 'Forest Hill' },
    { name: 'Fort Bliss' },
    { name: 'Fort Hood' },
    { name: 'Fort Stockton' },
    { name: 'Fort Worth' },
    { name: 'Fredericksburg' },
    { name: 'Freeport' },
    { name: 'Fresno' },
    { name: 'Friendswood' },
    { name: 'Frisco' },
    { name: 'Gainesville' },
    { name: 'Galena Park' },
    { name: 'Galveston' },
    { name: 'Garland' },
    { name: 'Gatesville' },
    { name: 'Georgetown' },
    { name: 'Gladewater' },
    { name: 'Glenn Heights' },
    { name: 'Gonzales' },
    { name: 'Graham' },
    { name: 'Grand Prairie' },
    { name: 'Grapevine' },
    { name: 'Greatwood' },
    { name: 'Greenville' },
    { name: 'Groves' },
    { name: 'Haltom City' },
    { name: 'Harker Heights' },
    { name: 'Harlingen' },
    { name: 'Henderson' },
    { name: 'Hereford' },
    { name: 'Hewitt' },
    { name: 'Hidalgo' },
    { name: 'Highland Park' },
    { name: 'Highland Village' },
    { name: 'Highlands' },
    { name: 'Hillsboro' },
    { name: 'Hitchcock' },
    { name: 'Homestead Meadows South' },
    { name: 'Hondo' },
    { name: 'Houston' },
    { name: 'Humble' },
    { name: 'Huntsville' },
    { name: 'Hurst' },
    { name: 'Ingleside' },
    { name: 'Iowa Park' },
    { name: 'Irving' },
    { name: 'Jacinto City' },
    { name: 'Jacksonville' },
    { name: 'Jasper' },
    { name: 'Jersey Village' },
    { name: 'Jollyville' },
    { name: 'Katy' },
    { name: 'Kaufman' },
    { name: 'Keller' },
    { name: 'Kerrville' },
    { name: 'Kilgore' },
    { name: 'Killeen' },
    { name: 'Kingsville' },
    { name: 'Kirby' },
    { name: 'La Feria' },
    { name: 'La Homa' },
    { name: 'La Marque' },
    { name: 'La Porte' },
    { name: 'Lackland AFB' },
    { name: 'Lake Dallas' },
    { name: 'Lake Jackson' },
    { name: 'Lakeway' },
    { name: 'Lamesa' },
    { name: 'Lampasas' },
    { name: 'Lancaster' },
    { name: 'Laredo' },
    { name: 'League City' },
    { name: 'Leander' },
    { name: 'Leon Valley' },
    { name: 'Levelland' },
    { name: 'Lewisville' },
    { name: 'Liberty' },
    { name: 'Littlefield' },
    { name: 'Live Oak' },
    { name: 'Lockhart' },
    { name: 'Longview' },
    { name: 'Lubbock' },
    { name: 'Lufkin' },
    { name: 'Lumberton' },
    { name: 'Mansfield' },
    { name: 'Marlin' },
    { name: 'Marshall' },
    { name: 'McAllen' },
    { name: 'McKinney' },
    { name: 'Mercedes' },
    { name: 'Mesquite' },
    { name: 'Mexia' },
    { name: 'Midland' },
    { name: 'Midlothian' },
    { name: 'Mineral Wells' },
    { name: 'Mission' },
    { name: 'Mission Bend' },
    { name: 'Missouri City' },
    { name: 'Monahans' },
    { name: 'Mount Pleasant' },
    { name: 'Nacogdoches' },
    { name: 'Navasota' },
    { name: 'Nederland' },
    { name: 'New Braunfels' },
    { name: 'New Territory' },
    { name: 'North Richland Hills' },
    { name: 'Odessa' },
    { name: 'Orange' },
    { name: 'Palestine' },
    { name: 'Palmview South' },
    { name: 'Pampa' },
    { name: 'Paris' },
    { name: 'Pasadena' },
    { name: 'Pearland' },
    { name: 'Pearsall' },
    { name: 'Pecan Grove' },
    { name: 'Pecos' },
    { name: 'Perryton' },
    { name: 'Pflugerville' },
    { name: 'Pharr' },
    { name: 'Plainview' },
    { name: 'Plano' },
    { name: 'Pleasanton' },
    { name: 'Port Arthur' },
    { name: 'Port Lavaca' },
    { name: 'Port Neches' },
    { name: 'Portland' },
    { name: 'Raymondville' },
    { name: 'Rendon' },
    { name: 'Richardson' },
    { name: 'Richland Hills' },
    { name: 'Richmond' },
    { name: 'Rio Grande City' },
    { name: 'River Oaks' },
    { name: 'Robinson' },
    { name: 'Robstown' },
    { name: 'Rockport' },
    { name: 'Rockwall' },
    { name: 'Roma' },
    { name: 'Rosenberg' },
    { name: 'Round Rock' },
    { name: 'Rowlett' },
    { name: 'Sachse' },
    { name: 'Saginaw' },
    { name: 'San Angelo' },
    { name: 'San Antonio' },
    { name: 'San Benito' },
    { name: 'San Elizario' },
    { name: 'San Juan' },
    { name: 'San Marcos' },
    { name: 'Santa Fe' },
    { name: 'Schertz' },
    { name: 'Seabrook' },
    { name: 'Seagoville' },
    { name: 'Seguin' },
    { name: 'Sherman' },
    { name: 'Silsbee' },
    { name: 'Slaton' },
    { name: 'Snyder' },
    { name: 'Socorro' },
    { name: 'South Houston' },
    { name: 'Southlake' },
    { name: 'Spring' },
    { name: 'Stafford' },
    { name: 'Stephenville' },
    { name: 'Sugar Land' },
    { name: 'Sulphur Springs' },
    { name: 'Sweetwater' },
    { name: 'Taylor' },
    { name: 'Temple' },
    { name: 'Terrell' },
    { name: 'Texarkana' },
    { name: 'Texas City' },
    { name: 'The Colony' },
    { name: 'The Woodlands' },
    { name: 'Tomball' },
    { name: 'Trophy Club' },
    { name: 'Tyler' },
    { name: 'Universal City' },
    { name: 'University Park' },
    { name: 'Uvalde' },
    { name: 'Vernon' },
    { name: 'Victoria' },
    { name: 'Vidor' },
    { name: 'Waco' },
    { name: 'Watauga' },
    { name: 'Waxahachie' },
    { name: 'Weatherford' },
    { name: 'Webster' },
    { name: 'Wells Branch' },
    { name: 'Weslaco' },
    { name: 'West Livingston' },
    { name: 'West Odessa' },
    { name: 'West University Place' },
    { name: 'Wharton' },
    { name: 'White Settlement' },
    { name: 'Wichita Falls' },
    { name: 'Windemere' },
    { name: 'Woodway' },
    { name: 'Wylie' },
  ],
  'utah': [
    { name: 'Alpine' },
    { name: 'American Fork' },
    { name: 'Bountiful' },
    { name: 'Brigham City' },
    { name: 'Canyon Rim' },
    { name: 'Cedar City' },
    { name: 'Centerville' },
    { name: 'Clearfield' },
    { name: 'Clinton' },
    { name: 'Cottonwood Heights' },
    { name: 'Cottonwood West' },
    { name: 'Draper' },
    { name: 'East Millcreek' },
    { name: 'Farmington' },
    { name: 'Grantsville' },
    { name: 'Heber' },
    { name: 'Highland' },
    { name: 'Holladay' },
    { name: 'Hurricane' },
    { name: 'Hyrum' },
    { name: 'Kaysville' },
    { name: 'Kearns' },
    { name: 'Layton' },
    { name: 'Lehi' },
    { name: 'Lindon' },
    { name: 'Little Cottonwood Creek Valley' },
    { name: 'Logan' },
    { name: 'Magna' },
    { name: 'Midvale' },
    { name: 'Millcreek' },
    { name: 'Mount Olympus' },
    { name: 'Murray' },
    { name: 'North Logan' },
    { name: 'North Ogden' },
    { name: 'North Salt Lake' },
    { name: 'Ogden' },
    { name: 'Oquirrh' },
    { name: 'Orem' },
    { name: 'Park City' },
    { name: 'Payson' },
    { name: 'Pleasant Grove' },
    { name: 'Price' },
    { name: 'Provo' },
    { name: 'Richfield' },
    { name: 'Riverdale' },
    { name: 'Riverton' },
    { name: 'Roy' },
    { name: 'Salt Lake City' },
    { name: 'Sandy' },
    { name: 'Smithfield' },
    { name: 'South Jordan' },
    { name: 'South Ogden' },
    { name: 'South Salt Lake' },
    { name: 'Spanish Fork' },
    { name: 'Springville' },
    { name: 'St. George' },
    { name: 'Summit Park' },
    { name: 'Syracuse' },
    { name: 'Taylorsville' },
    { name: 'Tooele' },
    { name: 'Vernal' },
    { name: 'Washington' },
    { name: 'Washington Terrace' },
    { name: 'West Jordan' },
    { name: 'West Point' },
    { name: 'West Valley City' },
    { name: 'Woods Cross' },
  ],
  'vermont': [
    { name: 'Barre' },
    { name: 'Bennington' },
    { name: 'Brattleboro' },
    { name: 'Burlington' },
    { name: 'Colchester' },
    { name: 'Essex' },
    { name: 'Essex Junction' },
    { name: 'Hartford' },
    { name: 'Middlebury' },
    { name: 'Milton' },
    { name: 'Montpelier' },
    { name: 'Rutland' },
    { name: 'Shelburne' },
    { name: 'South Burlington' },
    { name: 'Springfield' },
    { name: 'St. Albans' },
    { name: 'St. Johnsbury' },
    { name: 'Swanton' },
    { name: 'Williston' },
    { name: 'Winooski' },
  ],
  'virginia': [
    { name: 'Abingdon' },
    { name: 'Alexandria' },
    { name: 'Annandale' },
    { name: 'Aquia Harbour' },
    { name: 'Arlington' },
    { name: 'Ashland' },
    { name: 'Bailey’s Crossroads' },
    { name: 'Bedford' },
    { name: 'Belle Haven' },
    { name: 'Blacksburg' },
    { name: 'Bon Air' },
    { name: 'Bristol' },
    { name: 'Buena Vista' },
    { name: 'Bull Run' },
    { name: 'Burke' },
    { name: 'Cave Spring' },
    { name: 'Centreville' },
    { name: 'Chantilly' },
    { name: 'Charlottesville' },
    { name: 'Chesapeake' },
    { name: 'Chester' },
    { name: 'Christiansburg' },
    { name: 'Collinsville' },
    { name: 'Colonial Heights' },
    { name: 'Covington' },
    { name: 'Culpeper' },
    { name: 'Dale City' },
    { name: 'Danville' },
    { name: 'Dumbarton' },
    { name: 'Dunn Loring' },
    { name: 'East Highland Park' },
    { name: 'Fairfax' },
    { name: 'Falls Church' },
    { name: 'Farmville' },
    { name: 'Forest' },
    { name: 'Fort Belvoir' },
    { name: 'Fort Hunt' },
    { name: 'Fort Lee' },
    { name: 'Franconia' },
    { name: 'Franklin' },
    { name: 'Fredericksburg' },
    { name: 'Front Royal' },
    { name: 'Galax' },
    { name: 'Glen Allen' },
    { name: 'Gloucester Point' },
    { name: 'Great Falls' },
    { name: 'Groveton' },
    { name: 'Hampton' },
    { name: 'Harrisonburg' },
    { name: 'Herndon' },
    { name: 'Highland Springs' },
    { name: 'Hollins' },
    { name: 'Hopewell' },
    { name: 'Huntington' },
    { name: 'Hybla Valley' },
    { name: 'Idylwood' },
    { name: 'Jefferson' },
    { name: 'Lake Barcroft' },
    { name: 'Lake Monticello' },
    { name: 'Lake Ridge' },
    { name: 'Lakeside' },
    { name: 'Laurel' },
    { name: 'Leesburg' },
    { name: 'Lexington' },
    { name: 'Lincolnia' },
    { name: 'Linton Hall' },
    { name: 'Lorton' },
    { name: 'Lynchburg' },
    { name: 'Madison Heights' },
    { name: 'Manassas' },
    { name: 'Manassas Park' },
    { name: 'Mantua' },
    { name: 'Marion' },
    { name: 'Martinsville' },
    { name: 'McLean' },
    { name: 'Mechanicsville' },
    { name: 'Merrifield' },
    { name: 'Montclair' },
    { name: 'Montrose' },
    { name: 'Mount Vernon' },
    { name: 'Newington' },
    { name: 'Newport News' },
    { name: 'Norfolk' },
    { name: 'North Springfield' },
    { name: 'Oakton' },
    { name: 'Petersburg' },
    { name: 'Pimmit Hills' },
    { name: 'Poquoson' },
    { name: 'Portsmouth' },
    { name: 'Pulaski' },
    { name: 'Quantico Station' },
    { name: 'Radford' },
    { name: 'Reston' },
    { name: 'Richmond' },
    { name: 'Roanoke' },
    { name: 'Rose Hill' },
    { name: 'Salem' },
    { name: 'Seven Corners' },
    { name: 'Smithfield' },
    { name: 'South Boston' },
    { name: 'Springfield' },
    { name: 'Staunton' },
    { name: 'Stuarts Draft' },
    { name: 'Sudley' },
    { name: 'Suffolk' },
    { name: 'Timberlake' },
    { name: 'Tuckahoe' },
    { name: 'Tysons Corner' },
    { name: 'Vienna' },
    { name: 'Vinton' },
    { name: 'Virginia Beach' },
    { name: 'Warrenton' },
    { name: 'Waynesboro' },
    { name: 'West Gate' },
    { name: 'West Springfield' },
    { name: 'Williamsburg' },
    { name: 'Winchester' },
    { name: 'Wolf Trap' },
    { name: 'Woodbridge' },
    { name: 'Wyndham' },
    { name: 'Wytheville' },
    { name: 'Yorkshire' },
  ],
  'washington': [
    { name: 'Aberdeen' },
    { name: 'Alderwood Manor' },
    { name: 'Anacortes' },
    { name: 'Arlington' },
    { name: 'Artondale' },
    { name: 'Auburn' },
    { name: 'Bainbridge Island' },
    { name: 'Bangor Trident Base' },
    { name: 'Battle Ground' },
    { name: 'Bellevue' },
    { name: 'Bellingham' },
    { name: 'Bonney Lake' },
    { name: 'Bothell' },
    { name: 'Bremerton' },
    { name: 'Brier' },
    { name: 'Bryn Mawr-Skyway' },
    { name: 'Burien' },
    { name: 'Burlington' },
    { name: 'Camano' },
    { name: 'Camas' },
    { name: 'Cascade-Fairwood' },
    { name: 'Centralia' },
    { name: 'Chehalis' },
    { name: 'Cheney' },
    { name: 'Clarkston' },
    { name: 'Clarkston Heights-Vineland' },
    { name: 'College Place' },
    { name: 'Cottage Lake' },
    { name: 'Covington' },
    { name: 'Des Moines' },
    { name: 'Dishman' },
    { name: 'East Hill-Meridian' },
    { name: 'East Renton Highlands' },
    { name: 'East Wenatchee Bench' },
    { name: 'Edgewood' },
    { name: 'Edmonds' },
    { name: 'Elk Plain' },
    { name: 'Ellensburg' },
    { name: 'Enumclaw' },
    { name: 'Ephrata' },
    { name: 'Everett' },
    { name: 'Fairwood' },
    { name: 'Federal Way' },
    { name: 'Ferndale' },
    { name: 'Five Corners' },
    { name: 'Fort Lewis' },
    { name: 'Gig Harbor' },
    { name: 'Graham' },
    { name: 'Grandview' },
    { name: 'Hazel Dell North' },
    { name: 'Hazel Dell South' },
    { name: 'Hobart' },
    { name: 'Hoquiam' },
    { name: 'Inglewood-Finn Hill' },
    { name: 'Issaquah' },
    { name: 'Kelso' },
    { name: 'Kenmore' },
    { name: 'Kennewick' },
    { name: 'Kent' },
    { name: 'Kingsgate' },
    { name: 'Kirkland' },
    { name: 'Lacey' },
    { name: 'Lake Forest Park' },
    { name: 'Lake Morton-Berrydale' },
    { name: 'Lake Shore' },
    { name: 'Lake Stevens' },
    { name: 'Lakeland North' },
    { name: 'Lakeland South' },
    { name: 'Lakewood' },
    { name: 'Lea Hill' },
    { name: 'Longview' },
    { name: 'Lynden' },
    { name: 'Lynnwood' },
    { name: 'Maltby' },
    { name: 'Maple Valley' },
    { name: 'Martha Lake' },
    { name: 'Marysville' },
    { name: 'Mercer Island' },
    { name: 'Midland' },
    { name: 'Mill Creek' },
    { name: 'Mill Plain' },
    { name: 'Minnehaha' },
    { name: 'Monroe' },
    { name: 'Moses Lake' },
    { name: 'Mount Vernon' },
    { name: 'Mountlake Terrace' },
    { name: 'Mukilteo' },
    { name: 'Newcastle' },
    { name: 'Normandy Park' },
    { name: 'North Creek' },
    { name: 'North Marysville' },
    { name: 'Oak Harbor' },
    { name: 'Olympia' },
    { name: 'Opportunity' },
    { name: 'Orchards' },
    { name: 'Otis Orchards-East Farms' },
    { name: 'Paine Field-Lake Stickney' },
    { name: 'Parkland' },
    { name: 'Parkwood' },
    { name: 'Pasco' },
    { name: 'Picnic Point-North Lynnwood' },
    { name: 'Port Angeles' },
    { name: 'Port Orchard' },
    { name: 'Port Townsend' },
    { name: 'Poulsbo' },
    { name: 'Prairie Ridge' },
    { name: 'Pullman' },
    { name: 'Puyallup' },
    { name: 'Redmond' },
    { name: 'Renton' },
    { name: 'Richland' },
    { name: 'Riverton-Boulevard Park' },
    { name: 'Salmon Creek' },
    { name: 'Sammamish' },
    { name: 'SeaTac' },
    { name: 'Seattle' },
    { name: 'Seattle Hill-Silver Firs' },
    { name: 'Sedro-Woolley' },
    { name: 'Selah' },
    { name: 'Shelton' },
    { name: 'Shoreline' },
    { name: 'Silverdale' },
    { name: 'Snohomish' },
    { name: 'South Hill' },
    { name: 'Spanaway' },
    { name: 'Spokane' },
    { name: 'Steilacoom' },
    { name: 'Summit' },
    { name: 'Sumner' },
    { name: 'Sunnyside' },
    { name: 'Tacoma' },
    { name: 'Terrace Heights' },
    { name: 'Toppenish' },
    { name: 'Tukwila' },
    { name: 'Tumwater' },
    { name: 'Union Hill-Novelty Hill' },
    { name: 'University Place' },
    { name: 'Vancouver' },
    { name: 'Vashon' },
    { name: 'Veradale' },
    { name: 'Walla Walla' },
    { name: 'Waller' },
    { name: 'Walnut Grove' },
    { name: 'Washington' },
    { name: 'Washougal' },
    { name: 'Wenatchee' },
    { name: 'West Lake Stevens' },
    { name: 'West Richland' },
    { name: 'West Valley' },
    { name: 'White Center' },
    { name: 'Woodinville' },
    { name: 'Yakima' },
  ],
  'west-virginia': [
    { name: 'Beckley' },
    { name: 'Bluefield' },
    { name: 'Bridgeport' },
    { name: 'Charleston' },
    { name: 'Cheat Lake' },
    { name: 'Clarksburg' },
    { name: 'Cross Lanes' },
    { name: 'Dunbar' },
    { name: 'Elkins' },
    { name: 'Fairmont' },
    { name: 'Huntington' },
    { name: 'Martinsburg' },
    { name: 'Morgantown' },
    { name: 'Moundsville' },
    { name: 'Nitro' },
    { name: 'Oak Hill' },
    { name: 'Parkersburg' },
    { name: 'Pea Ridge' },
    { name: 'Princeton' },
    { name: 'South Charleston' },
    { name: 'St. Albans' },
    { name: 'Teays Valley' },
    { name: 'Vienna' },
    { name: 'Weirton' },
    { name: 'Wheeling' },
  ],
  'wisconsin': [
    { name: 'Allouez' },
    { name: 'Altoona' },
    { name: 'Antigo' },
    { name: 'Appleton' },
    { name: 'Ashland' },
    { name: 'Ashwaubenon' },
    { name: 'Baraboo' },
    { name: 'Beaver Dam' },
    { name: 'Bellevue' },
    { name: 'Bellevue Town' },
    { name: 'Beloit' },
    { name: 'Brookfield' },
    { name: 'Brown Deer' },
    { name: 'Burlington' },
    { name: 'Caledonia' },
    { name: 'Cedarburg' },
    { name: 'Chippewa Falls' },
    { name: 'Cudahy' },
    { name: 'De Pere' },
    { name: 'DeForest' },
    { name: 'Delafield' },
    { name: 'Delavan' },
    { name: 'Eau Claire' },
    { name: 'Elkhorn' },
    { name: 'Elm Grove' },
    { name: 'Fitchburg' },
    { name: 'Fond du Lac' },
    { name: 'Fort Atkinson' },
    { name: 'Fox Point' },
    { name: 'Franklin' },
    { name: 'Genesee' },
    { name: 'Germantown' },
    { name: 'Glendale' },
    { name: 'Grafton' },
    { name: 'Grand Chute' },
    { name: 'Grand Rapids' },
    { name: 'Green Bay' },
    { name: 'Greendale' },
    { name: 'Greenfield' },
    { name: 'Greenville' },
    { name: 'Hales Corners' },
    { name: 'Hartford' },
    { name: 'Hartland' },
    { name: 'Holmen' },
    { name: 'Howard' },
    { name: 'Hudson' },
    { name: 'Janesville' },
    { name: 'Jefferson' },
    { name: 'Kaukauna' },
    { name: 'Kenosha' },
    { name: 'Kimberly' },
    { name: 'La Crosse' },
    { name: 'Lake Geneva' },
    { name: 'Lisbon' },
    { name: 'Little Chute' },
    { name: 'Madison' },
    { name: 'Manitowoc' },
    { name: 'Marinette' },
    { name: 'Marshfield' },
    { name: 'McFarland' },
    { name: 'Menasha' },
    { name: 'Menomonee Falls' },
    { name: 'Menomonie' },
    { name: 'Mequon' },
    { name: 'Merrill' },
    { name: 'Merton' },
    { name: 'Middleton' },
    { name: 'Milwaukee' },
    { name: 'Monona' },
    { name: 'Monroe' },
    { name: 'Mount Pleasant' },
    { name: 'Mukwonago' },
    { name: 'Muskego' },
    { name: 'Neenah' },
    { name: 'New Berlin' },
    { name: 'New London' },
    { name: 'New Richmond' },
    { name: 'Norway' },
    { name: 'Oak Creek' },
    { name: 'Oconomowoc' },
    { name: 'Onalaska' },
    { name: 'Oregon' },
    { name: 'Oshkosh' },
    { name: 'Pewaukee' },
    { name: 'Platteville' },
    { name: 'Pleasant Prairie' },
    { name: 'Plover' },
    { name: 'Plymouth' },
    { name: 'Port Washington' },
    { name: 'Portage' },
    { name: 'Prairie du Chien' },
    { name: 'Racine' },
    { name: 'Reedsburg' },
    { name: 'Rhinelander' },
    { name: 'Rib Mountain' },
    { name: 'Rice Lake' },
    { name: 'Richfield' },
    { name: 'Ripon' },
    { name: 'River Falls' },
    { name: 'Salem' },
    { name: 'Shawano' },
    { name: 'Sheboygan' },
    { name: 'Sheboygan Falls' },
    { name: 'Shorewood' },
    { name: 'Somers' },
    { name: 'South Milwaukee' },
    { name: 'Sparta' },
    { name: 'St. Francis' },
    { name: 'Stevens Point' },
    { name: 'Stoughton' },
    { name: 'Sturgeon Bay' },
    { name: 'Suamico' },
    { name: 'Sun Prairie' },
    { name: 'Superior' },
    { name: 'Sussex' },
    { name: 'Tomah' },
    { name: 'Two Rivers' },
    { name: 'Vernon' },
    { name: 'Verona' },
    { name: 'Washington' },
    { name: 'Watertown' },
    { name: 'Waukesha' },
    { name: 'Waunakee' },
    { name: 'Waupun' },
    { name: 'Wausau' },
    { name: 'Wauwatosa' },
    { name: 'West Allis' },
    { name: 'West Bend' },
    { name: 'Weston' },
    { name: 'Whitefish Bay' },
    { name: 'Whitewater' },
    { name: 'Wisconsin Rapids' },
  ],
  'wyoming': [
    { name: 'Casper' },
    { name: 'Cheyenne' },
    { name: 'Cody' },
    { name: 'Evanston' },
    { name: 'Gillette' },
    { name: 'Green River' },
    { name: 'Jackson' },
    { name: 'Lander' },
    { name: 'Laramie' },
    { name: 'Rawlins' },
    { name: 'Riverton' },
    { name: 'Rock Springs' },
    { name: 'Sheridan' },
  ],
};
